var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-community",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-community:not(.animated) .animable {opacity: 0;}svg#freepik_stories-community.animated #freepik--Floor--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--Shadows--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--Plants--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--Woman--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--family-2--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--family-1--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-community.animated #freepik--boy-with-wheelchair--inject-12 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-12",
    className: "animable",
    style: {
      transformOrigin: "249.53px 338.25px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-12",
    cx: 249.53,
    cy: 338.25,
    rx: 238,
    ry: 137.41,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "249.53px 338.25px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-12",
    className: "animable",
    style: {
      transformOrigin: "242.47px 330.305px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-12",
    cx: 388.39,
    cy: 263.47,
    rx: 30.75,
    ry: 17.75,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "388.39px 263.47px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 318.17,
    cy: 256.27,
    rx: 39.37,
    ry: 22.73,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "318.17px 256.27px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 246.82,
    cy: 251.93,
    rx: 39.37,
    ry: 22.73,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "246.82px 251.93px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 140.9,
    cy: 259.82,
    rx: 32.49,
    ry: 18.76,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.9px 259.82px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 99.36,
    cy: 393.76,
    rx: 34.34,
    ry: 19.82,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "99.36px 393.76px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 156.12,
    cy: 390.55,
    rx: 34.34,
    ry: 19.82,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "156.12px 390.55px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 215.21,
    cy: 388.2,
    rx: 38.07,
    ry: 21.98,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "215.21px 388.2px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-12",
    cx: 347.05,
    cy: 389.34,
    rx: 72.87,
    ry: 42.07,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "347.05px 389.34px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "254.691px 221.945px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "89.9415px 220.941px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.3,252.36l8-4.64s4.78-19.86,2.87-37.74C110.52,184.85,94,175.4,87.69,177.57S79.58,187.05,90,202C96.13,210.84,103.67,229.24,102.3,252.36Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "98.0952px 214.815px"
    },
    id: "eluyjo7ox9qc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcyeg9hd7b5"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "98.0952px 214.815px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.3,252.36l8-4.64s4.78-19.86,2.87-37.74C110.52,184.85,94,175.4,87.69,177.57S79.58,187.05,90,202C96.13,210.84,103.67,229.24,102.3,252.36Z",
    id: "el844751s1ztb",
    className: "animable",
    style: {
      transformOrigin: "98.0952px 214.815px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M105.62,242.61h-.07a.57.57,0,0,1-.45-.66c4.41-23.17-3.69-49.22-13.72-60.06a.56.56,0,1,1,.82-.75c10.21,11,18.47,37.5,14,61A.56.56,0,0,1,105.62,242.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "99.313px 211.757px"
    },
    id: "elh2fhr3n6sx4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.25,264.52c-1.27.64-4.64-2.25-5.58-2.95A11.78,11.78,0,0,1,72,256.88a11,11,0,0,1-.64-6.67,26.15,26.15,0,0,1,1-3.48c.39-1.13.77-2.25,1.16-3.37a8.7,8.7,0,0,0,.67-3.43c-.18-2.35-2.17-4.09-4-5.6-2-1.67-4.07-3.84-3.92-6.65a9.87,9.87,0,0,1,2.78-5.77c1.43-1.64,3.1-3.06,4.41-4.8a7,7,0,0,0,1.64-4.31,7.25,7.25,0,0,0-.82-2.78c-.9-1.88-2.13-3.62-2.71-5.63s-.37-4.45,1.24-5.78c1.32-1.09,3.2-1.16,4.9-1a11.17,11.17,0,0,1,4.43,1.82c4.34,2.71,6.63,8.13,11.27,10.28a47.45,47.45,0,0,0,5.67,1.69c1.88.6,3.78,1.67,4.57,3.48,1.57,3.57-1.88,7.69-.84,11.44.92,3.32,4,4.73,5.66,7.76a7,7,0,0,1,.62,4.32,20.6,20.6,0,0,1-2.17,7.14,63.68,63.68,0,0,1-4.29,6.59S81.45,264.42,81.25,264.52Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "87.7293px 231.079px"
    },
    id: "elkk1darv0g7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.55,258.11h0a.56.56,0,0,1-.51-.61c2-22.05-7.14-47-14.36-54.43a.56.56,0,1,1,.81-.77c7.35,7.61,16.72,32.95,14.66,55.3A.56.56,0,0,1,93.55,258.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "86.4694px 230.105px"
    },
    id: "elaftuvwwp9ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.36,230.92a.41.41,0,0,1-.16,0,75.06,75.06,0,0,0-15.91-3.39.56.56,0,0,1-.5-.61.54.54,0,0,1,.61-.5,76.21,76.21,0,0,1,16.18,3.45.56.56,0,0,1,.33.72A.55.55,0,0,1,91.36,230.92Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.3663px 228.672px"
    },
    id: "elnpjhbzwri4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-12",
    className: "animable",
    style: {
      transformOrigin: "422.394px 230.202px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.84,263.81l-8.9-5s-.84-16.27.43-29.25c1.8-18.25,13.58-40.2,27.63-35s-6.44,23.73-11,39.21S410.84,263.81,410.84,263.81Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "418.259px 228.797px"
    },
    id: "elszev7yunbv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elui014llwm07"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M410.84,263.81l-8.9-5s-.84-16.27.43-29.25c1.8-18.25,13.58-40.2,27.63-35s-6.44,23.73-11,39.21S410.84,263.81,410.84,263.81Z",
    style: {
      opacity: 0.15,
      transformOrigin: "418.259px 228.797px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406.73,261.9h0a.48.48,0,0,0,.46-.49c-1.37-40.54,18.81-60.93,19-61.13a.46.46,0,0,0,0-.67.47.47,0,0,0-.67,0c-.2.2-20.68,20.89-19.29,61.84A.47.47,0,0,0,406.73,261.9Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "416.249px 230.685px"
    },
    id: "elc5nbz15qxi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.77,266.62l-5.58-3.21s-.94-11.51,4.7-25.48c4.91-12.17,17.09-22.26,23.22-20.14s6,6.47,3,11S419.93,244.24,415.77,266.62Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "426.626px 242.063px"
    },
    id: "elr65ngmuod69",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.83,265.4h0a.47.47,0,0,0,.47-.47c-.11-25.64,24-43,24.2-43.13A.47.47,0,1,0,437,221c-.24.17-24.71,17.78-24.6,43.9A.48.48,0,0,0,412.83,265.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "425.061px 243.164px"
    },
    id: "el6akfbr3zjgu",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Woman--inject-12",
    className: "animable",
    style: {
      transformOrigin: "133.707px 160.677px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-12",
    className: "animable",
    style: {
      transformOrigin: "133.707px 160.677px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.06,127.85c-5.38-28.77-6.21-34.73-6.9-40.65,8.09-.85,12.3,3.9,13.78,12.42.73,4.16,1.4,21,3.33,27.75,1.7,5.88,4,12.23,7.76,17.23a4.28,4.28,0,0,0,2.54,1.65c2.31.81,3,2.08,4.89,3.33,1.47,1,2.56,1,2.49,1.48a2,2,0,0,1-2.31,1.47,10.71,10.71,0,0,1-2.76-.77,20.67,20.67,0,0,0,4.05,4.09c3.63,2.82,3.44,5.66-2.27,7-3.58.85-6.95-.71-11.45-8-1.3-2.1-4-5.85-5.44-8.63C159.29,137.62,157,132.69,156.06,127.85Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "167.259px 125.081px"
    },
    id: "ellf6rrc7w1mi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.42,86.49s5.61-.27,8.07,2.7,4.34,4.22,5.19,13,1.84,17.83,2.15,21.28,7.3,19.9,7.3,19.9a12.3,12.3,0,0,0-7.61,5.88s-7-11.2-9.35-18.26a77.21,77.21,0,0,1-3.68-17C151.76,108,150.42,86.49,150.42,86.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "161.775px 117.867px"
    },
    id: "el1y4au95kguf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.08,47.41h0a16.85,16.85,0,0,1,16.85,16.85v15.2a11.11,11.11,0,0,1-11.11,11.11H124.24a0,0,0,0,1,0,0V64.26a16.85,16.85,0,0,1,16.85-16.85Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "141.085px 68.99px"
    },
    id: "elo9aoyu2tkp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elko2thb0q3v"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.08,47.41h0a16.85,16.85,0,0,1,16.85,16.85v15.2a11.11,11.11,0,0,1-11.11,11.11H124.24a0,0,0,0,1,0,0V64.26a16.85,16.85,0,0,1,16.85-16.85Z",
    style: {
      opacity: 0.15,
      transformOrigin: "141.085px 68.99px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.14,265c-.76-.67-1.52-1.33-2.2-2-2.14-1.95-3.77-5.27-4.7-7.53a10.47,10.47,0,0,1-.81-4.06V247h-7.71v7.16h0v.19l0,0c.37,1.61,3.91,5.88,5.92,8.66,1.34,1.87,3.9,4.24,7,4.65C138.54,268.08,140,267.16,138.14,265Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "130.844px 257.38px"
    },
    id: "elxot1rarc0u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,257.43c-.39,1.79.18,6.67.18,6.67a6.47,6.47,0,0,0,3.59,2.72l1.06-6.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "123.107px 262.125px"
    },
    id: "elqu45y9dh4l9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.53 266.82 130.53 264.68 131.85 259.26 125.14 262.88 124.53 266.82",
    id: "el8b2yuz26z48",
    className: "animable",
    style: {
      transformOrigin: "128.19px 263.04px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.43,251v-1.27c.83.38,2.8,7,5.36,11.45,2.34,4.1,6.82,6.31,8.3,8.08,2,2.37-1.67,5.58-7.7,4.45-3-.57-7.55-2.36-8.82-4.35s-1.78-5.66-2.81-7.12-3.45-3.1-4-4.77c-.3-.92.11-2.92.58-4.6s.86-3.41,1.38-3.26v1.17c.42.81,1.22,1.68,4.25,1.76C128.41,252.55,129.8,252.29,130.43,251Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "132.648px 261.772px"
    },
    id: "elg0smb3ndb6c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.22,261.65c-.76-.68-1.52-1.34-2.21-2-2.14-2-3.77-5.27-4.7-7.54a13.9,13.9,0,0,1-.84-4.7v-3.67l-7.69-.11v7.18h0V251l0,0c.37,1.61,3.91,5.89,5.92,8.67,1.35,1.87,3.92,4.25,7,4.66C163.62,264.77,165.1,263.85,163.22,261.65Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "155.919px 254.034px"
    },
    id: "elc8ux8mc9ms5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.81,253.9c-.4,1.8.18,6.68.18,6.68a6.52,6.52,0,0,0,3.58,2.72l1.07-6.83Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "148.155px 258.6px"
    },
    id: "el19q5vlbc0ueh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.57 263.3 155.57 261.15 156.9 255.74 150.19 259.36 149.57 263.3",
    id: "elbo6b6x4zgx4",
    className: "animable",
    style: {
      transformOrigin: "153.235px 259.52px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47,247.44v-1.28c.84.38,2.81,7,5.37,11.46,2.33,4.1,6.82,6.31,8.3,8.08,2,2.37-1.68,5.58-7.71,4.44-3-.56-7.54-2.36-8.81-4.34s-1.78-5.67-2.82-7.12-3.45-3.1-4-4.78c-.3-.91.1-2.91.57-4.59s.87-3.41,1.4-3.25v1.18c.42.81,1.2,1.65,4.24,1.74C153.46,249,154.85,248.77,155.47,247.44Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "157.692px 258.214px"
    },
    id: "ela3c24ab8q1n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.35,133.5c-6.18,13.54.22,61.21.22,61.21-.18,2.2-3.11,7.11-2.91,15.88.26,11.47,2.6,35.74,3.06,39s3.32,3.36,7.71.38c0,0,5.91-41.83,7.34-53.18C139,186.86,141,169.2,141,169.2L144,197.53s-2.13,7.37-2.19,11.62c-.1,8.76,5.42,32.33,5.95,36.91,1.08,2.16,2.68,1.83,7.69-.79,0,0,2.47-41.21,3.07-49.25,1-13.52-1-60-3.44-68Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "139.217px 190.072px"
    },
    id: "elzpkyr5cl3re",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el09m57927esjn"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15,
      transformOrigin: "148.405px 169.865px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141,169.2l2.46-16.7s8.5-1.76,12.35-5.39a22,22,0,0,1-10,6.68l-2.26,9.68,0,29.15Z",
    id: "el03otzo7jx1f",
    className: "animable",
    style: {
      transformOrigin: "148.405px 169.865px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.88,87.5l-5.5.27L123,93.93c-.43,3.51-1.71,8-.55,11.37l3.6,15.87A24.52,24.52,0,0,1,125,125.7a82.44,82.44,0,0,0-6,18.44c-5.69,32.53-4.63,67.21-4.63,98.58,13.86,7.75,42.63,2.17,46.79-3.49.06-.41-.74-75.79-5-114.14a6.41,6.41,0,0,1-.41-4.3l1.54-7.52c3.45-5.37,3.75-10.6,1.93-14.37-3-6.14-7.25-10.45-9.41-11.13a22.61,22.61,0,0,0-5.65-.68Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "137.727px 166.808px"
    },
    id: "el5t16doxtiwn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elz7aclfq0i19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.88,87.5l-5.5.27L123,93.93c-.43,3.51-1.71,8-.55,11.37l3.6,15.87A24.52,24.52,0,0,1,125,125.7a82.44,82.44,0,0,0-6,18.44c-5.69,32.53-4.63,67.21-4.63,98.58,13.86,7.75,42.63,2.17,46.79-3.49.06-.41-.74-75.79-5-114.14a6.41,6.41,0,0,1-.41-4.3l1.54-7.52c3.45-5.37,3.75-10.6,1.93-14.37-3-6.14-7.25-10.45-9.41-11.13a22.61,22.61,0,0,0-5.65-.68Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "137.727px 166.808px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M124.88,87.08c-6.71.25-8.1,4.83-12.38,10.86-3,4.28-8.12,11-8.12,11s-8.8-12.84-9.29-14.76c-.59-2.31.18-3.34,0-5.88s-.68-4.19-.31-5.35-1.75-1-2.29.52-.23,3.3-.87,3.1-1.93-4-2.08-6.88-1.87-3.28-2.25-2.26a8.45,8.45,0,0,0-.45,1.69,3.7,3.7,0,0,0-3.46,1.66c-1.08,1.93-1.84,4.6-.9,8.74s3.74,6.79,4.72,8.46c1.45,2.5,6.68,17,12.35,23.92,2.6,3.14,5.72,2.12,8.07-.35l15-15.83C127.23,101.34,129,90.15,124.88,87.08Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "104.624px 100.391px"
    },
    id: "elfsz70nygtpm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.87,86.49s-5.46-.67-8.56,2.7-13.93,19.71-13.93,19.71L95.09,94.14S93.91,98,87.62,98.75c0,0,3,7.62,5.34,13.28s6,12.45,9.78,12.45,5-1.86,12-9.19,11-11.76,11-11.76S130.39,94.84,126.87,86.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "107.904px 105.458px"
    },
    id: "el4yw60xu380h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.29,85h10a0,0,0,0,1,0,0v11.8a10,10,0,0,1-10,10h0a0,0,0,0,1,0,0V85A0,0,0,0,1,130.29,85Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "135.29px 95.9px"
    },
    id: "eln3hn7emwzqd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3awubvqb2k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.29,85h10a0,0,0,0,1,0,0v11.8a10,10,0,0,1-10,10h0a0,0,0,0,1,0,0V85A0,0,0,0,1,130.29,85Z",
    style: {
      opacity: 0.3,
      transformOrigin: "135.29px 95.9px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.41,56c2.27,1.63,3,3.49,2.8,13.84-.21,8.78-3.05,11-4.47,11.58s-4.18.24-6.85-.2v6.22a5.27,5.27,0,0,1,1.77,3.08c.18.65-2,1.66-7.29.94a7,7,0,0,1-5.48-3.58V68.24s0-8,5.71-11.08A16,16,0,0,1,152.41,56Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "144.066px 73.3297px"
    },
    id: "el4ju6svyy7y8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.89,68.24s5.2-9.29,12.77-10.42,9.25,2.67,9.25,2.67-1-8.59-9.25-8.37C134.24,52.43,132.89,61.18,132.89,68.24Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "143.9px 60.1779px"
    },
    id: "elkd08dya192j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloxgzgm14xid"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.89,68.24s5.2-9.29,12.77-10.42,9.25,2.67,9.25,2.67-1-8.59-9.25-8.37C134.24,52.43,132.89,61.18,132.89,68.24Z",
    style: {
      opacity: 0.4,
      transformOrigin: "143.9px 60.1779px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144,67.64a1.1,1.1,0,1,1-2.2.1,1.11,1.11,0,0,1,1-1.19A1.13,1.13,0,0,1,144,67.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "142.899px 67.6714px"
    },
    id: "el02zt04394p6a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.4,75.1l2.56.81a1.31,1.31,0,0,1-1.66.92A1.4,1.4,0,0,1,144.4,75.1Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "145.651px 75.995px"
    },
    id: "elr31kqk1e3lg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,64.39l-2.23-1.55a1.29,1.29,0,0,1,1.85-.38A1.44,1.44,0,0,1,153.5,64.39Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "152.494px 63.3054px"
    },
    id: "el1qo2rirlqm9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.75,64.25,143,62.7a1.29,1.29,0,0,0-1.85-.38A1.43,1.43,0,0,0,140.75,64.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.767px 63.1654px"
    },
    id: "el7u9jzp6op9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.62,67.41a1.1,1.1,0,1,1-2.2.1,1.11,1.11,0,0,1,1-1.19A1.13,1.13,0,0,1,152.62,67.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.519px 67.4395px"
    },
    id: "eldk00zv6bgxw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.33 66.68 147.5 73.33 150.99 72.24 147.33 66.68",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "149.16px 70.005px"
    },
    id: "elcbl2eg0go8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.89,81.22c-2.82-.37-8.61-2-9.51-4.34a6,6,0,0,0,2,2.93c1.73,1.49,7.48,3.16,7.48,3.16Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "139.135px 79.925px"
    },
    id: "el5wxmqkpsbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.46,82.38l-3.56-1.16a1.16,1.16,0,0,1-1.16,1.16h-5.58a4.28,4.28,0,0,1-4.27-4.29l-3.55,4.29h-5.1v6.75a4.17,4.17,0,0,0,4.16,4.18h15.39a10.16,10.16,0,0,0,10.15-10.18v-.75Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "139.09px 85.7px"
    },
    id: "elo9ojdvvb3vr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elakxnl0tk02l"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.46,82.38l-3.56-1.16a1.16,1.16,0,0,1-1.16,1.16h-5.58a4.28,4.28,0,0,1-4.27-4.29l-3.55,4.29h-5.1v6.75a4.17,4.17,0,0,0,4.16,4.18h15.39a10.16,10.16,0,0,0,10.15-10.18v-.75Z",
    style: {
      opacity: 0.15,
      transformOrigin: "139.09px 85.7px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,120.79s-2.12,1.86-12.52,2.34a49,49,0,0,1-17.22-2L125,125.7s7,2.66,18.13,2.27,13.08-2.88,13.08-2.88Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "140.605px 124.4px"
    },
    id: "eloszqs517wdp",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--family-2--inject-12",
    className: "animable",
    style: {
      transformOrigin: "304.171px 157.974px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--family-2--inject-12",
    className: "animable",
    style: {
      transformOrigin: "304.171px 157.974px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.29,115.84c-1.78,4.85-7.89,19.53-8.9,21.65A50.74,50.74,0,0,0,284.9,144c-.7,2.58-5.41,9.58-3.13,10.94,4.09,2.42,7.53-2.18,8.83-4a89.5,89.5,0,0,0,5.2-8.48c2.92-5.23,5.59-9.79,7.85-14.7,1.74-3.77,6.55-21.17,7.94-25.5,1.89-5.87,3.52-22.45,3.52-22.45-5.9,0-9.17,1.2-10.73,4.12-3,5.58-4.3,13.06-5.6,19.76C297.61,109.79,296.29,115.84,296.29,115.84Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "298.131px 117.719px"
    },
    id: "el05e0vg7khe8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.17,100.09a105.52,105.52,0,0,0,6.76,22.29c2.94,6.42,7.24,14.24,8.62,17.8a5,5,0,0,1-.15,2.88c-.51,2.08-.12,3.08-.71,5.22-.47,1.69-.76,2.21-.43,2.49a2,2,0,0,0,2.67-.41,14.36,14.36,0,0,0,1.82-2.76,18.3,18.3,0,0,1-.22,5.9c-.85,4.47,2.25,4.91,5.19,3.74,3.37-1.35,4.39-4.68,3-13a55,55,0,0,0-3-9.52c-3.51-8.55-6.17-13.95-8.74-20.18-2.12-9-4.27-19-6.78-24.85-1.34-3.1-5.66-5.34-10.67-4.93C259.18,90.29,261.17,100.09,261.17,100.09Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "273.426px 121.252px"
    },
    id: "elopqms5d7jog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.8,147.89c1.22-.94,4.14-2.88,5.13-1.57s1.17,5.35.26,7.06-4,1.65-4.25,3.46C277.21,156.07,276.22,149.87,278.8,147.89Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "281.041px 151.36px"
    },
    id: "elk21eumdi5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arms--inject-12",
    className: "animable",
    style: {
      transformOrigin: "306.315px 95.1081px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.11,78.82s-6.83-.31-10,3.18c-4.35,4.73-5.73,16.7-7.59,25.87,3.89,4.4,10.46,4.42,13.16,1.55Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "306.315px 95.1081px"
    },
    id: "el7x3xz08cuwg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elznhirn7rj1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      transformOrigin: "306.315px 95.1081px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.11,78.82s-6.83-.31-10,3.18c-4.35,4.73-5.73,16.7-7.59,25.87,3.89,4.4,10.46,4.42,13.16,1.55Z",
    id: "elxfe8o32oq0b",
    className: "animable",
    style: {
      transformOrigin: "306.315px 95.1081px"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Men--inject-12",
    className: "animable",
    style: {
      transformOrigin: "333.588px 156.497px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 335.46,
    y: 240.77,
    width: 8.26,
    height: 14.13,
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "339.59px 247.835px"
    },
    id: "el7ovqyfaao6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.61 240.72 304.35 241 303.94 226.04 312.61 225.76 312.61 240.72",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "308.275px 233.38px"
    },
    id: "elhxg2e8sk0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.66,135.27c.6,18.24.64,55.54.64,55.54.19,2.27,2.38,6.31,2.55,14.48.24,11.85-.78,42.54-.78,42.54a10.86,10.86,0,0,1-9.19.18s-7.29-42.26-8.77-54c-1.29-10.24-3.48-38.05-3.48-38.05l-4.47,33.42a115.8,115.8,0,0,1,.3,15.73c-.38,5.43-5.33,31-5.33,31a11.26,11.26,0,0,1-9.53.73s-.88-42.44-1-47.42c-.11-5.67.51-63.89.51-63.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "323.737px 187.236px"
    },
    id: "elw8h3mu7lbio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.46,250.82v-1.18c-.79.35-2.62,7.35-5.9,10.34-2.6,2.37-6.16,5.12-7.06,7.77s4.95,4.27,7.38,3.84c2.83-.5,7.73-2.49,9-4.34s1.8-4.56,2.8-5.92,3.31-2.86,3.85-4.42c.29-.86-.06-2.75-.48-4.34s-.79-3.06-1.29-2.93v.9a6.49,6.49,0,0,1-4.13,1.4C338.38,252,335.45,251.75,335.46,250.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.022px 260.645px"
    },
    id: "elz5sc41fgan",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.27,238.45c-.43,0-.78.62-1.73,1.65a18.1,18.1,0,0,1-4.85,3.49c-3.09,1.55-9.11,3.93-11.83,5.16-1.69.76-1.62,2.81.14,4s6,2,11.09.87c2.78-.62,6.39-3.18,8.67-3s6.57.1,8.25-1.06,1-3.65.54-5.78c-.52-2.33-1.17-6-1.94-5.8v.8c-1,1.5-6.12,2.11-8.3,1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "299.859px 246.067px"
    },
    id: "elafzxo9j9oys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.63,156a30.39,30.39,0,0,1-11.49-6.59s2.21,4.16,8.81,8l-1.41,29.13Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "316.885px 167.975px"
    },
    id: "elyuxx8o3ne7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.47,78.6a76.86,76.86,0,0,1,11.7,1.8c2.54,1,3.8,2.86,3.88,5.93.26,10.54-2.52,32.53-2.52,32.53l1.53,18.21C337,142.14,315,144.12,302.71,136c0,0,1.3-35.91,2.49-41.83,2.14-10.66,6.38-15.21,10.3-15.38Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "322.889px 110.044px"
    },
    id: "elbycb0vy05y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.61,53.52a10.7,10.7,0,1,1-10.79-10.6A10.69,10.69,0,0,1,327.61,53.52Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "316.91px 53.6196px"
    },
    id: "elmzn86z4m8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.47,61.06s-1.66,8.15-2.34,9.5A3.7,3.7,0,0,1,331,72.29l.07-5.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "333.235px 66.675px"
    },
    id: "el0omplcrd6v8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.19,49.41a4,4,0,0,1,3.33,1.14c1.44,1.45.69,6-1,10.51l-3.26.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "334.771px 55.4192px"
    },
    id: "elqt8pc9s15d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.23,61.47c.66.39,1.58-.88,2.38-1.73s3.43-2,4.76.73-1.1,6.56-3.17,7.23c-3.56,1.15-4.12-1.13-4.12-1.13l-.15,13.29h0c-4.39,5.74-16.73,5.36-11.65-.63l0-3.93a22.55,22.55,0,0,1-4.82.29c-2.63-.38-4.3-2.44-5.12-5.28-1.33-4.56-1.84-8.25-.84-17.25,1.11-9.86,12.57-10.07,18.79-6.23S331.23,61.47,331.23,61.47Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "323.362px 64.2329px"
    },
    id: "el69seykwo4qp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.24,62.57c.33,0,1.56-2.08,2.37-2.83,1.12-1-.42-10.33-.42-10.33a4.49,4.49,0,0,0-.82-5c-1.56-1.69-3.74-3.75-10.75-2.86-5,.63-10.43,2.24-14.84.12a7.48,7.48,0,0,0,2.67,7.93s1.61,1,5.8,1.49a62.2,62.2,0,0,0,11.6-.32c1.21-.18,1.48,1,2.16,4.2C329.61,57.78,330.13,62.56,331.24,62.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "320.265px 51.9527px"
    },
    id: "elu397ojwzs9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.19,50.14,337.13,48a2.18,2.18,0,0,0-3-1A2.37,2.37,0,0,0,333.19,50.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "335.03px 48.4419px"
    },
    id: "elkgu7jgq29uj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.26,75.3s5.86-1.23,7.9-2.34A6.72,6.72,0,0,0,330,70.13a9.28,9.28,0,0,1-1.58,3.32c-1.48,1.93-9.12,3.41-9.12,3.41Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "324.63px 73.495px"
    },
    id: "elay5trjmd96",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.54,60.1a1.18,1.18,0,1,0,1.16-1.24A1.2,1.2,0,0,0,320.54,60.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "321.719px 60.0399px"
    },
    id: "el7b7oxmnts7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.75,55.65,324.28,57a1.52,1.52,0,0,0-.61-2A1.4,1.4,0,0,0,321.75,55.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "323.095px 55.9199px"
    },
    id: "elg07yah1oi9i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.73,68.23l-2.68,1a1.42,1.42,0,0,0,1.84.88A1.52,1.52,0,0,0,319.73,68.23Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "318.43px 69.2143px"
    },
    id: "el28zhu91w8u7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,56.73l2.28-1.79a1.4,1.4,0,0,0-2-.29A1.53,1.53,0,0,0,310,56.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "310.997px 55.542px"
    },
    id: "elgczvresknij",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.75,59.85a1.18,1.18,0,1,0,1.17-1.24A1.21,1.21,0,0,0,310.75,59.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "311.929px 59.79px"
    },
    id: "elaa9ya6uu2d7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.74 58.68 316.41 65.76 312.71 64.53 316.74 58.68",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "314.725px 62.22px"
    },
    id: "el2xg2keaa9qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.17,155.16,362.11,166l-14.84-10.36-3.37,7.14a116.42,116.42,0,0,0,12.38,9.73c2,1.27,6,4.58,9.1,2.23,3.46-2.59,10.47-9,10.47-9l6.69-15.41C378,149.82,375.81,151.6,372.17,155.16Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "363.22px 162.903px"
    },
    id: "elrkdqpntnq3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhi0yv2jtcyn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.27,155.68l-1.12,2.38-2.25,4.76.65.58.12.1.36.33.52.45.07.06,1.32,1.13.15.12.7.59.15.12a7,7,0,0,0,6.11-5.89Z",
    style: {
      fill: "rgb(242, 143, 143)",
      opacity: 0.5,
      transformOrigin: "348.975px 160.99px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M356.46,143.52a84.1,84.1,0,0,1-1.36,10.17c-2.25,8.68-5.14,11.28-9,11.54-6.14.41-6.18-1.89-3.42-5.84a19.75,19.75,0,0,0,2.74-5.65,14.67,14.67,0,0,1-2.95,1.9,2.09,2.09,0,0,1-2.76-.75c-.21-.41.86-.83,2-2.26,1.5-1.83,2.09-3.15,4.15-4.67a3.62,3.62,0,0,0,1-2.79c0-1.68-1.32-20.18-1.32-24.74l-5.53-18.58C337.72,90,339.3,82,340.81,81c8.65,2.28,8.92,8.44,15.6,33.18C357.59,118.54,357.14,136.79,356.46,143.52Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "347.999px 123.138px"
    },
    id: "eljyga0uwem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.44,153.74c3.26-.05,5.05,2.92,3,5.32s-6.76,1.93-6.76,1.93l-.41.85c-.69-.33-1.6-1.43-.93-3.31C341.12,156.37,342.51,153.79,345.44,153.74Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "344.709px 157.79px"
    },
    id: "elek47mtn6xqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.17,80.4s-3.05,9.39-.32,18l4.61,17.46c5.72-.33,10.55-1.07,12.81-5.45,0,0-3.66-12.76-5.48-18.44C349.13,86.8,348,82,339.17,80.4Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "346.992px 98.13px"
    },
    id: "el9h668csl77l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el36g8qhtsgp7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.17,80.4s-3.05,9.39-.32,18l4.61,17.46c5.72-.33,10.55-1.07,12.81-5.45,0,0-3.66-12.76-5.48-18.44C349.13,86.8,348,82,339.17,80.4Z",
    style: {
      opacity: 0.1,
      transformOrigin: "346.992px 98.13px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--woman--inject-12",
    className: "animable",
    style: {
      transformOrigin: "238.306px 159.906px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.79,247.37a40.52,40.52,0,0,0-.62,6.5c-.07,3.95-.8,5.35-.89,8.59-.11,3.7.53,5.08,2,7.16s5.44,4,7.11.45,1.45-5.82.92-9.45-.62-5.82-.94-8.69c-.28-2.52-.62-4.44-.62-4.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "231.482px 259.707px"
    },
    id: "eldvziacfps8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.88,212.56l-13-.24c.2,8.68-.31,26.9-.09,35.05.05,1.53,0,11.91.54,15.06.87,4.74,6.5,4.1,6.8,1.27s-.37-15-.35-16.21c-.05-5.22,4.29-22.63,5.57-32C240.41,215,240.82,213,240.88,212.56Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "234.307px 239.114px"
    },
    id: "elet0mqzhgjpt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.51,240.92s-.66,0-.76.57-.15,1.63-.41,2.67a15,15,0,0,0-.45,5c.22,1.18,2.91,2.93,4.75,3.24s4.43,2.13,5.87,3.48a14.07,14.07,0,0,0,8.17,3.22c3.07,0,5.21-1,6.22-2.67s-.92-1.84-4.43-4.12l-2.72-1.77c-5.56-3.63-7.59-5.58-9.17-9.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "268.506px 250.01px"
    },
    id: "el754wb2vo9hj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.54,238.86c-.1-2.61,1.6-25.79,1.6-25.79l-10.33,1.35c1.42,18.24,2,24.46,1.67,26.69h0a2.51,2.51,0,0,0-.06.65c0,3,3.37,4.58,6,6.57,1,.79,3.7,3.2,6.82,4.27,2,.68,5.75,1,6.23-.28-3.19-2.44-7.54-5.63-10.08-8.41C265.18,242.58,264.63,241.47,264.54,238.86Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "266.14px 233.133px"
    },
    id: "elkvg5z60iqk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.32,130.9c-3.7,16.23,0,54.73,0,54.73-.17,2-2.48,6-3.33,14.84-1,10.47-.49,42.1-.49,42.1a9.41,9.41,0,0,0,7.89.15s8.57-44.79,9.89-55.2c1.14-9.08,5.87-31,5.87-31l5.25,31a54.52,54.52,0,0,0-2,9c-.59,6.12,2.83,40.33,2.83,40.33a10.65,10.65,0,0,0,7.54-.1s4.39-43.21,5-50.59c.74-9.87-.84-40.63-1.83-55Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "248.666px 187.207px"
    },
    id: "elfw0rwo7u5yb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcugv5ih2c4r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.32,130.9c-3.7,16.23,0,54.73,0,54.73-.17,2-2.48,6-3.33,14.84-1,10.47-.49,42.1-.49,42.1a9.41,9.41,0,0,0,7.89.15s8.57-44.79,9.89-55.2c1.14-9.08,5.87-31,5.87-31l5.25,31a54.52,54.52,0,0,0-2,9c-.59,6.12,2.83,40.33,2.83,40.33a10.65,10.65,0,0,0,7.54-.1s4.39-43.21,5-50.59c.74-9.87-.84-40.63-1.83-55Z",
    style: {
      opacity: 0.5,
      transformOrigin: "248.666px 187.207px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eli5m14x0pnc"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.14,156.49l1.35-9.25s7.81-1,11.35-4.37a12.84,12.84,0,0,1-9.21,5.82l-1.38,8.36,2.61,27.32Z",
    style: {
      opacity: 0.1,
      transformOrigin: "257.49px 163.62px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.62,109.14l-.29,6.89a124.77,124.77,0,0,1,2,16.54c-14.51,7.74-34.73,2.91-37.48-.28.54-5.7,5.84-13.26,7.35-15.83l-3-11.64s8-7.19,1.77-18.93l8.28-.89,10.86-.35,2.49.09c2.11,1.63,6.31,4.43,9,9.47C269.07,97,270.86,101.62,266.62,109.14Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "250.056px 110.692px"
    },
    id: "el7vvd4atjyst",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.26,85.76c-6.71.25-8.1,4.83-12.38,10.86-3,4.28-8.12,11-8.12,11s-8.8-12.84-9.29-14.76c-.59-2.31.18-3.34,0-5.88s-.67-4.19-.31-5.35-1.74-1-2.28.52-.23,3.3-.88,3.1-1.93-4-2.07-6.88-1.88-3.27-2.25-2.26a8.45,8.45,0,0,0-.45,1.69,3.69,3.69,0,0,0-3.46,1.66c-1.08,1.93-1.84,4.6-.9,8.74s3.74,6.79,4.71,8.46c1.45,2.5,6.69,17,12.36,23.92,2.59,3.14,5.72,2.12,8.06-.35l15-15.83C240.61,100,242.36,88.83,238.26,85.76Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "218.005px 99.0729px"
    },
    id: "eltb61g8kczt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,79.28l-3.58.14A14.89,14.89,0,0,1,234,65.1h0a16.69,16.69,0,0,1,16-17.32h0a16.7,16.7,0,0,1,17.33,16h0A14.9,14.9,0,0,1,253.05,79.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.665px 63.5996px"
    },
    id: "el548w2tq7ckw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49,87.47h0a11.51,11.51,0,0,0,11-11.93L236,62.3h0A11.49,11.49,0,0,0,225,74.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "230.745px 74.885px"
    },
    id: "el57vqzug4sds",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.28,54.38c1.86,1,4.28,5.49,4.43,15.09.12,8.13-2.43,10.24-3.73,10.87s-3.87.38-6.37.06l.19,4.88s4.61,7,2.48,8.59c-3.28,2.48-8.45-.51-9.94-2.19A14.73,14.73,0,0,1,244,86.05l-.37-11.22s-1.41,1.47-4-.59c-2.11-1.71-2.91-4.7-1.38-6.38a3.56,3.56,0,0,1,5.7.91s1.51,1.41,2.87-1.35C256.32,65.71,261,59,260.28,54.38Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "251.085px 74.598px"
    },
    id: "el56n2nbi1s1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.38,67.08a1,1,0,1,1-1.11-1A1,1,0,0,1,254.38,67.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.38px 67.0739px"
    },
    id: "el2pubmsvdr68",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.09,74.66l2.41.66a1.22,1.22,0,0,1-1.51.91A1.3,1.3,0,0,1,256.09,74.66Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "257.275px 75.4663px"
    },
    id: "elhwjk7cq70p4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.23,63.78l-2.12-1.35a1.19,1.19,0,0,1,1.7-.42A1.32,1.32,0,0,1,263.23,63.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.26px 62.7962px"
    },
    id: "el8ywi27y6h1u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,63.25l-2.31,1a1.21,1.21,0,0,1,.61-1.65A1.32,1.32,0,0,1,253.41,63.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.192px 63.3741px"
    },
    id: "el1hygbtquo5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.78,66.76a1,1,0,1,1-1.11-1A1,1,0,0,1,262.78,66.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "261.78px 66.7539px"
    },
    id: "elt6abfg52xa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.56 66.37 257.96 72.52 261.16 71.39 257.56 66.37",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "259.36px 69.445px"
    },
    id: "elthznyh56phi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.61,80.4c-2.62-.24-8.06-1.58-9-3.68a5.52,5.52,0,0,0,2,2.65c1.66,1.31,7.06,2.66,7.06,2.66Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "250.14px 79.375px"
    },
    id: "elhx6k5o6e0s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,63.18l-4.54.17h0A2.22,2.22,0,0,1,231.75,61a2.38,2.38,0,0,1,2.43,2.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "231.908px 62.1747px"
    },
    id: "elcyccgfdgkv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.07,62.88l-3.16-3.26h0a2.19,2.19,0,0,1,3.18,0,2.38,2.38,0,0,1,0,3.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "232.83px 60.923px"
    },
    id: "el8u5j2s9sv7r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.94,68.77l.17,4.28h0a2.92,2.92,0,0,0,2.8-3l-.16-4Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "245.426px 69.55px"
    },
    id: "elx5utsttyikq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,107.08a8.84,8.84,0,0,0,7.81,4.46,9.86,9.86,0,0,0,8.79-4.21s-.51,5.67-8.8,5.67C242.6,113,242,107.08,242,107.08Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "250.3px 110.04px"
    },
    id: "elpxlxkgvm7v",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kid--inject-12",
    className: "animable",
    style: {
      transformOrigin: "388.484px 196.47px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.45,149.48l-17.57-1.08L374,131.64c.53-7.84,8.2-13.81,16-13.28h0a14.22,14.22,0,0,1,13.23,15.15l-.34,5.06A11.73,11.73,0,0,1,390.45,149.48Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "388.071px 133.915px"
    },
    id: "elxpljaq132as",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.93,187.54l29.45.68c.72,13.62,1.31,33.74,1.31,33.74.16,1.82,1.79,4.85,2,11.68.27,10.52-.05,20,0,22.41h0l.17,4.33h0v.16l0,0c-.16,2-6.71,4.13-6.71,2.82,0,0,.85-1.46-.47-8-.92-4.63-5.69-21-7.61-30.23-1.55-7.42-3.91-19.87-3.91-19.87l-2.71,16.12a55,55,0,0,1,.1,9.74c-.86,7.21-2.32,17.43-2.47,21.41.41,5.23-3.72,4.55-6.7,4,0,0,0-.44-.06-1.6l-.09-2.34c-.5-5.53-2.4-26.68-2.83-32.46C371.54,208.91,372.88,196.16,372.93,187.54Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "388.986px 225.652px"
    },
    id: "elmxvl772yxph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.75,264.81c.34.11.15,1.17,0,1.52a3.66,3.66,0,0,1-1.86,1.4,5.32,5.32,0,0,0-3,2.24,6,6,0,0,1-3.41,3.64,10,10,0,0,1-6.85.69c-1.92-.57-2.53-1.53-2.64-2a11.1,11.1,0,0,1,0-2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "397.943px 269.712px"
    },
    id: "elzld8y84e5wl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.05,266.91a5.4,5.4,0,0,0,2.67-1.73c.19-2.27-.5-2.88-.42-4.13.15-2.46-.2-2.29-.49-2.17,0,.3,0,1,0,1A3.21,3.21,0,0,1,405,261a1.78,1.78,0,0,1-1.2.2,1,1,0,0,1-.48-.16,1.43,1.43,0,0,1-.32-.44,3.9,3.9,0,0,0-1-1.28,4,4,0,0,0-3.23-.7,1.13,1.13,0,0,0-.38.12c-.27.18-.23.57-.3.89a9.46,9.46,0,0,1-2.71,4,14.23,14.23,0,0,1-2.57,2.21,12.58,12.58,0,0,0-2.72,2,3.81,3.81,0,0,0-.84,3.4,2.93,2.93,0,0,0,1.92,1.81,8.79,8.79,0,0,0,5.76.05,6.79,6.79,0,0,0,3.91-3.09A6.55,6.55,0,0,1,404.05,266.91Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "397.949px 266.045px"
    },
    id: "elmx5bxu2rf2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eleclodkxndr7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.05,266.91a5.4,5.4,0,0,0,2.67-1.73c.19-2.27-.5-2.88-.42-4.13.15-2.46-.2-2.29-.49-2.17,0,.3,0,1,0,1A3.21,3.21,0,0,1,405,261a1.78,1.78,0,0,1-1.2.2,1,1,0,0,1-.48-.16,1.43,1.43,0,0,1-.32-.44,3.9,3.9,0,0,0-1-1.28,4,4,0,0,0-3.23-.7,1.13,1.13,0,0,0-.38.12c-.27.18-.23.57-.3.89a9.46,9.46,0,0,1-2.71,4,14.23,14.23,0,0,1-2.57,2.21,12.58,12.58,0,0,0-2.72,2,3.81,3.81,0,0,0-.84,3.4,2.93,2.93,0,0,0,1.92,1.81,8.79,8.79,0,0,0,5.76.05,6.79,6.79,0,0,0,3.91-3.09A6.55,6.55,0,0,1,404.05,266.91Z",
    style: {
      opacity: 0.5,
      transformOrigin: "397.949px 266.045px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.9,262.61a5,5,0,0,0-3.64-1.21.76.76,0,0,0-.58.78,5.46,5.46,0,0,1,3.88,1.26c.24.2.45.22.65,0S401.1,262.78,400.9,262.61Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "398.977px 262.492px"
    },
    id: "elh72q6iccnxp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.83,264.27A5.56,5.56,0,0,0,396,263s-.8.22-.81.83a5.16,5.16,0,0,1,4.09,1.24.49.49,0,0,0,.79-.16h0A.58.58,0,0,0,399.83,264.27Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "397.641px 264.1px"
    },
    id: "el1k26wq4ozy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.44,266.65a.54.54,0,0,0-.11-.71,5.59,5.59,0,0,0-3.82-1.42s-.95.26-1.08.86a6,6,0,0,1,4.19,1.38.56.56,0,0,0,.81-.09Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "395.978px 265.706px"
    },
    id: "elk2wsp68y7p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.3,268.91a4.29,4.29,0,0,1,1.08,3.51,6.89,6.89,0,0,1-1.45.64,8.79,8.79,0,0,1-5.76-.05c-.82-.31-2-.92-2.26-1.86a4.24,4.24,0,0,1,1-3.6,3.09,3.09,0,0,1,1.28-.83h0C392.88,266.17,395.81,267.21,397.3,268.91Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "393.631px 270.046px"
    },
    id: "elznri7i0ktf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,257.58c.34.11.16,1.18,0,1.52a3.66,3.66,0,0,1-1.86,1.4,5.4,5.4,0,0,0-3,2.24,6,6,0,0,1-3.41,3.64,10,10,0,0,1-6.84.69c-1.93-.57-2.54-1.52-2.65-2a12.16,12.16,0,0,1,0-2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "374.196px 262.481px"
    },
    id: "elqdls0rq8lt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,259.68A5.35,5.35,0,0,0,383,258c.19-2.26-.5-2.88-.42-4.13.15-2.45-.2-2.29-.49-2.17,0,.3,0,1,0,1a3.19,3.19,0,0,1-.82,1.16,1.79,1.79,0,0,1-1.2.2,1,1,0,0,1-.48-.16,1.27,1.27,0,0,1-.33-.43,3.59,3.59,0,0,0-4.22-2,1,1,0,0,0-.38.11c-.27.19-.23.57-.3.89a9.46,9.46,0,0,1-2.71,4,14.23,14.23,0,0,1-2.57,2.21,12.22,12.22,0,0,0-2.71,2,3.82,3.82,0,0,0-.85,3.4,2.93,2.93,0,0,0,1.93,1.81,8.59,8.59,0,0,0,5.75.05,6.76,6.76,0,0,0,3.91-3.09A6.55,6.55,0,0,1,380.32,259.68Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "374.226px 258.877px"
    },
    id: "el8hqmej8np6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eliwqe1q8d77f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.32,259.68A5.35,5.35,0,0,0,383,258c.19-2.26-.5-2.88-.42-4.13.15-2.45-.2-2.29-.49-2.17,0,.3,0,1,0,1a3.19,3.19,0,0,1-.82,1.16,1.79,1.79,0,0,1-1.2.2,1,1,0,0,1-.48-.16,1.27,1.27,0,0,1-.33-.43,3.59,3.59,0,0,0-4.22-2,1,1,0,0,0-.38.11c-.27.19-.23.57-.3.89a9.46,9.46,0,0,1-2.71,4,14.23,14.23,0,0,1-2.57,2.21,12.22,12.22,0,0,0-2.71,2,3.82,3.82,0,0,0-.85,3.4,2.93,2.93,0,0,0,1.93,1.81,8.59,8.59,0,0,0,5.75.05,6.76,6.76,0,0,0,3.91-3.09A6.55,6.55,0,0,1,380.32,259.68Z",
    style: {
      opacity: 0.5,
      transformOrigin: "374.226px 258.877px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.17,255.38a4.93,4.93,0,0,0-3.64-1.2.73.73,0,0,0-.57.77,5.44,5.44,0,0,1,3.87,1.26c.24.2.46.22.66,0S377.38,255.55,377.17,255.38Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "375.256px 255.266px"
    },
    id: "elbtfk937uhyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.1,257a5.52,5.52,0,0,0-3.85-1.28s-.79.21-.81.82a5.15,5.15,0,0,1,4.09,1.24.49.49,0,0,0,.79-.16h0A.58.58,0,0,0,376.1,257Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "373.89px 256.814px"
    },
    id: "el8mvj03jh7gx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.72,259.42a.56.56,0,0,0-.12-.71,5.54,5.54,0,0,0-3.82-1.41s-.95.25-1.08.85a6,6,0,0,1,4.19,1.38.57.57,0,0,0,.82-.09Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "372.249px 258.481px"
    },
    id: "el9gek0f96qf6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.57,261.69a4.26,4.26,0,0,1,1.08,3.5,6.67,6.67,0,0,1-1.45.64,8.59,8.59,0,0,1-5.75-.05c-.83-.31-2-.92-2.27-1.86a4.24,4.24,0,0,1,1-3.6,3.07,3.07,0,0,1,1.29-.83h0C369.15,258.94,372.08,260,373.57,261.69Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "369.901px 262.822px"
    },
    id: "elc8nmyajscc9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.7,152.38a6.78,6.78,0,0,1,5.45,5.2,21.55,21.55,0,0,1,.51,4.71l-1.09,15.23,1.09,13.29c-4.35,4.74-20.29,6.1-29.78-.84,0,0,.47-24.26,1.18-29,1.24-8.3,5.69-10.84,9.69-10.53l9.57,1.37Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "387.77px 172.594px"
    },
    id: "el96j0lxo1m1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.07,181.87l-9,26.84s2.4,9,23.5,8.64,23-10.32,23-10.32L402,183.29Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "387.32px 199.615px"
    },
    id: "el5y19iahu3av",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.57,177.52a34.88,34.88,0,0,1-28.34-1.15c-.14,2.06-.21,3.93-.16,5.5,0,0,2.8,4.25,13.85,4.35,10,.09,15.12-2.93,15.12-2.93A36.13,36.13,0,0,0,401.57,177.52Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "387.547px 181.296px"
    },
    id: "elfskuq9rinx6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.09,192.17c-.21,2.79-.38,5.22-.45,7.35-.22,6.41-2.19,8.14-3.59,8.47-3.9.93-5.5-.81-4.17-3.67a13.36,13.36,0,0,0,.8-2.22c.06-.21.51-1.59,0-1.33a1,1,0,0,0-.29.28,2.65,2.65,0,0,1-2.23.95.64.64,0,0,1-.45-.19c-.18-.24,0-.57.17-.8a27,27,0,0,0,2.06-3.36,9.37,9.37,0,0,0,1.33-3.23c.07-.83.1-13.36-.62-16.38l-6.39-11.7c-2.51-5.54-3.81-11.53-.9-13.82,6.63.44,7.48,5.19,14.77,20.34C413.7,176.19,412.43,187.76,412.09,192.17Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "404.297px 180.381px"
    },
    id: "eliyi80eikkf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.8,137.34c.52.37.64.54,1.07-.32.94-1.87,4-2.37,4.9,0s-1.37,5.34-3.13,5.75c-3,.7-3.32-1.23-3.32-1.23l-1.05,10.64a9.52,9.52,0,0,1-7.59,4.9c-5.29.31-4.9-4.08-3-6.06l.23-3a12.72,12.72,0,0,1-3.85-.68c-1.63-.58-2.82-1.68-3.72-4.3-1.22-3.53-1.13-7.27.5-14.19,1.87-8,11.87-7.48,16.74-3.87S395.8,137.34,395.8,137.34Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "388.742px 139.782px"
    },
    id: "el3opbczs7ktp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.87,137l-.23,2.39h0a2.3,2.3,0,0,1-2.12-2.4l.25-5,3.24.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "396.264px 135.69px"
    },
    id: "elk5tayi142b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.77,118.53h0a13.17,13.17,0,0,0-14.43,11.78l-.17,1.7,6.41.65A6,6,0,0,0,385,128.1h0l-.29,5.18h0a4.78,4.78,0,0,0,5.17-3.85l.16-.83h0a5.65,5.65,0,0,0,5.08,5.74l1.54.06.62-9.2Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "384.725px 126.431px"
    },
    id: "elurquhhgeyhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.41,135.91a1.1,1.1,0,1,0,1.19-1.06A1.13,1.13,0,0,0,386.41,135.91Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "387.509px 135.947px"
    },
    id: "elneywkyvg7mq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.09,132.71l2.23,1.47a1.4,1.4,0,0,0-.4-1.9A1.31,1.31,0,0,0,388.09,132.71Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "389.311px 133.127px"
    },
    id: "elznep3g12zoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.92,142.31l-3.07.89a1.56,1.56,0,0,0,1.95,1.14A1.66,1.66,0,0,0,385.92,142.31Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "384.415px 143.355px"
    },
    id: "elg3dix7b5ge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.89,131.73l2.59-.73a1.28,1.28,0,0,0-1.61-.95A1.42,1.42,0,0,0,376.89,131.73Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "378.167px 130.864px"
    },
    id: "elzwhq5ska1e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.65,135.36a1.12,1.12,0,0,0,1,1.22,1.14,1.14,0,0,0,.18-2.28A1.12,1.12,0,0,0,377.65,135.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "378.764px 135.441px"
    },
    id: "eld99s08nn9rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.51 134.46 382.74 140.28 379.77 139.01 383.51 134.46",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "381.64px 137.37px"
    },
    id: "elrnx48s3pqxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.89,148s5.26-.14,7.74-1.47a6.65,6.65,0,0,0,2.52-2.15,6.56,6.56,0,0,1-1.54,2.64c-2.55,2.58-8.82,2.26-8.82,2.26Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "388.97px 146.836px"
    },
    id: "elxxjf1jo1lo",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--family-1--inject-12",
    className: "animable",
    style: {
      transformOrigin: "164.218px 286.231px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--family-1--inject-12",
    className: "animable",
    style: {
      transformOrigin: "164.218px 286.231px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--woman--inject-12",
    className: "animable",
    style: {
      transformOrigin: "171.215px 284.876px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208,203.78l-9,20.52s-13.8,11.6-23.89,20.56c-.74-2.61-1.58-12.17-1.58-12.17,4.26-5.22,14.53-15.88,16.2-17.73C195.55,208.48,200.93,203.25,208,203.78Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "190.765px 224.301px"
    },
    id: "elgyohibmd1cb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elcbii2jn06uv"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,165.46h1.48a17.25,17.25,0,0,1,17.25,17.25v31.61a22.88,22.88,0,0,1-22.88,22.88h-13.1a0,0,0,0,1,0,0V182.72A17.25,17.25,0,0,1,159,165.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "159.74px 201.33px",
      transform: "rotate(0.47deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M169,205.5c4.22.36,7.24,1.23,13.32,9.46,2.51,3.39,11,15.84,13.91,20.1,2.85.44,8.92,2.15,8.92,2.15,2.44,2.37.87,8,.45,10.07l-11.8-1.09a6.19,6.19,0,0,1-4.06-2.07c-8.81-10-14.7-17.22-14.7-17.22Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "187.742px 226.39px"
    },
    id: "el20zjwwmdlrb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,365.9c4.56-14.78,15.42-45.2,17-49.78,2-5.85.2-50.5-2.88-63.65l-34.72-.58c-7.69,10.59-7.69,20.36-5.41,44.49,1.1,11.51,2.59,24.78,2.59,24.78s-3.92,7.89-2.77,21.16c.5,5.85,2.11,23.73,3.37,31.37.28,2.14.45,4.24.53,6.22,0,.52.08,1,.08,1.52v1.29s8.8,7,8.8-2.53v-1.34l.39-5.68c.52-6.67,1.66-18.9,2.54-26.85,1.49-13.54,2.17-20.76,3-27.78,1.1-9.59,3.11-40.72,3.11-40.72l5.21,37a35.18,35.18,0,0,0-5.56,14.27c-.56,4.28-2,13.55-2.94,24.08-.39,4.19-.64,8.4-1.13,12.59-.1.8-.19,1.64-.28,2.58,0,0,8.38,1.46,8.61.37C162.8,367.35,163,365.9,163,365.9Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "158.254px 318.544px"
    },
    id: "elsehewm7d9m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.78,252.79a31.39,31.39,0,0,0-6.11,16.77c-.66,9-1.24,36.55-1.24,36.55s1.74,6.53,24.18,5.17S182,304.36,182,304.36s-.78-17.55-1.46-26.42-1.37-22.71-4.1-28Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "158.215px 280.703px"
    },
    id: "eldut21s6szm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.36,387c-.42,1.9.19,7.05.19,7.05a6.9,6.9,0,0,0,3.8,2.88l1.12-7.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.841px 391.965px"
    },
    id: "el0jdduj43xq2e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.35 396.96 149.71 394.69 151.11 388.96 144 392.79 143.35 396.96",
    id: "eluxcpkd4ckg",
    className: "animable",
    style: {
      transformOrigin: "147.23px 392.96px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,380.19v-1.34c.88.4,3,7.36,5.68,12.11,2.48,4.33,7.22,6.66,8.79,8.53,2.1,2.51-1.77,5.9-8.16,4.7-3.17-.59-8-2.49-9.34-4.59s-1.88-6-3-7.53-3.65-3.27-4.23-5a9.66,9.66,0,0,1-.11-4.92c.46-1.63.84-3.6,1.4-3.44l.07,1.24c.44.85,2,1.82,5.22,1.92C147.46,381.87,148.94,381.6,149.6,380.19Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "151.804px 391.57px"
    },
    id: "elhtjq3k5qtun",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.33,372.84c-.62,1.84-.57,7-.57,7a6.89,6.89,0,0,0,3.47,3.27l1.89-7.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "153.44px 377.975px"
    },
    id: "elt60x4v711f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.23 383.14 160.79 381.57 162.8 376.02 155.32 379.06 154.23 383.14",
    id: "eln20e2bq2xp",
    className: "animable",
    style: {
      transformOrigin: "158.515px 379.58px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.55,367.44l.49-1.54c.83.49,1.51,7.54,3.7,12.55,2,4.57,6.47,7.4,7.83,9.43,1.82,2.71-2.4,5.67-8.62,3.8-3.09-.94-7.68-3.34-8.8-5.57s-1.23-6.15-2.15-7.8-3.29-3.65-3.67-5.47c-.22-1,.44-3,1.12-4.76s1.3-3.48,1.84-3.26l-.13,1.24c.35.9,1.08,1.88,4.26,2.31C159.94,368.58,161.74,368.76,162.55,367.44Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "163.142px 378.534px"
    },
    id: "elizjr5a2mjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.11,244.05c.5-2.32,1.08-6.7,1.43-9.9,5.85-5.46,4.21-11.43,2.08-15.82-4.25-8.78-8.79-12.83-10.7-12.83h-12c-5.75.68-9.67,1.33-11.06,1.63-3.54.77-3.44,3.34-3.64,7.09a39.8,39.8,0,0,0,.38,11.61l4.84,10.46.43,6.43s-9.22,11.34-11.35,20.15a27.06,27.06,0,0,0,8.62-6.17s3.52,8.91,18.42,7.85c11.31-.8,15-7.44,15-7.44Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "159.047px 235.069px"
    },
    id: "el6hn24l66mys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el214tfkiq2up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.55,248.62c0,1.28,1.67,3.69,3,3.78a2.56,2.56,0,0,0,2.93-1.89c.72-1.68,0-5.91,0-5.91l-5.8,3.82Z",
    style: {
      opacity: 0.1,
      transformOrigin: "146.675px 248.52px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.56,238.39a14.29,14.29,0,0,0,2.13,5.69c.7,1.27-.05,8.13-3.13,7.13-2.44-.8-3.68-3.32-3.34-6.8a24.47,24.47,0,0,1,1.45-6.48,6.89,6.89,0,0,1,2.38-2.45l.37.8Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "146.548px 243.395px"
    },
    id: "elie0stnj6w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli2opqihui4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.45,228.85a9.38,9.38,0,0,0,8.2,6.06,9.89,9.89,0,0,0,9-4.14s-1.14,6.82-9.24,5.78S152.45,228.85,152.45,228.85Z",
    style: {
      opacity: 0.1,
      transformOrigin: "161.05px 232.754px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M170.53,172.71c2,1.12,4.54,6,4.55,16.38,0,8.8-2.79,11-4.21,11.7s-4.18.34-6.87,0l.12,5.28s7.61,7.92,1.47,8.85c-3.07.47-7-1.38-9.66-3.39a10.7,10.7,0,0,1-3.55-5.45l-.22-11.48s-1.54,1.57-4.27-.7c-2.26-1.88-3.08-5.12-1.4-6.91a3.86,3.86,0,0,1,6.16,1.07s1.57.09,3.08-2.87a19.26,19.26,0,0,0,8.31-1.54C171.08,180.53,171.29,175,170.53,172.71Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "160.339px 193.852px"
    },
    id: "el4vs3ywm3ikh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.66,186.6a1.11,1.11,0,1,1-1.19-1.07A1.14,1.14,0,0,1,163.66,186.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "162.551px 186.638px"
    },
    id: "el1duq7ftsb8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el55he4z7cbwt"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      transformOrigin: "166.597px 195.319px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.19,194.34l2.87.84a1.46,1.46,0,0,1-1.83,1.06A1.56,1.56,0,0,1,165.19,194.34Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "166.597px 195.319px"
    },
    id: "elyq2btr9jp1c",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M173.57,182.92l-2.28-1.49a1.31,1.31,0,0,1,1.85-.43A1.43,1.43,0,0,1,173.57,182.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "172.531px 181.852px"
    },
    id: "elwshpszmbgrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.41,182.08l-2.52,1a1.32,1.32,0,0,1,.69-1.77A1.43,1.43,0,0,1,162.41,182.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "161.09px 182.147px"
    },
    id: "el53p6rk4td3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173,186.13a1.12,1.12,0,0,1-1,1.23,1.14,1.14,0,0,1-1.19-1.07,1.1,1.1,0,1,1,2.2-.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "171.909px 186.234px"
    },
    id: "elcjr4nnevt2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmj54ucnlqf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      transformOrigin: "169.625px 188.955px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "167.72 185.63 168.05 192.28 171.53 191.11 167.72 185.63",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "169.625px 188.955px"
    },
    id: "elfqlvqt2fzz",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elol8m1zgr6t"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      transformOrigin: "159.195px 199.585px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164,200.75c-2.84-.3-8.69-1.83-9.65-4.11a5.91,5.91,0,0,0,2.11,2.89c1.77,1.44,7.58,3,7.58,3Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "159.195px 199.585px"
    },
    id: "elq9n4ywpiqi",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M152.65,188l.11,4.63h0a3.16,3.16,0,0,0,3.07-3.23l-.1-4.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "154.24px 188.88px"
    },
    id: "elnhm1zurmyma",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--woman--inject-12",
    className: "animable",
    style: {
      transformOrigin: "228.953px 283.22px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M198.88,202.5H218a15.73,15.73,0,0,0,15.73-15.73V183.2h0c.14-10-7.59-18.24-17.21-18.38h0c-9.61-.14-17.52,7.86-17.67,17.87v1C199,192.89,198.88,202.5,198.88,202.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.291px 183.659px"
    },
    id: "elcad3h2c27fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.6,187.45s-4.46-2.54-9.35-5.86a30.22,30.22,0,0,1-7.87-7.83s-.18,7.23,4.6,11.16,11.79,4,12,4.05S222.6,187.45,222.6,187.45Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "213.99px 181.366px"
    },
    id: "elitkvxhj55v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.46,173.19l3.93-2.31a2.16,2.16,0,0,0-3-1A2.53,2.53,0,0,0,230.46,173.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.286px 171.403px"
    },
    id: "el98s0jnwrnft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,172l1.17-4.54a2.18,2.18,0,0,0-2.79,1.57A2.49,2.49,0,0,0,230.37,172Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "230.107px 169.677px"
    },
    id: "eljmm7ce6zpx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62,370.41l-1.21-1.55c-.59,3.59-4,7.59-7.27,10.57-2.59,2.37-6.46,5.27-6.36,7.69.12,2.9,4.92,3.67,7.35,3.24,2.81-.5,6.46-2.1,8.44-4.54,1.39-1.71,3.37-4,4.36-5.3s3.29-2.85,3.83-4.41c.29-.86-.06-2.74-.47-4.32s-.8-3.05-1.29-2.92v.9c-.6.66-3.34,1.53-5.2,1.61C200.6,371.42,199.61,371.33,199.62,370.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "196.822px 379.665px"
    },
    id: "elph9si2dewak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.44,376.07a40.22,40.22,0,0,1,.64,6.65c.07,4,.82,5.47.91,8.78.12,3.79-.68,6.14-2.21,8.27s-6.45,3-8.15-.59-1.48-6-.94-9.67.64-6,1-8.89c.29-2.58.63-4.54.63-4.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "232.15px 388.846px"
    },
    id: "elngi7cuppk3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,330c-.94-9.74-2.34-13.82-2.53-16,0,0,2.22-22.94,2.81-42.28.28-9.31,0-19.73-8.85-30.61l-28.52-.45c-3.48,12.91-7,60.13-5.57,74.06.81,8.08,3.26,49,3.26,49v3.25a8.91,8.91,0,0,1-1.53,4.45,39.33,39.33,0,0,1-5.19,7.07,38.49,38.49,0,0,0-2.56,3c-2,2.34-.43,3.32,2.67,2.9,3.26-.43,6-3,7.43-4.95,2.14-3,7-7.72,7.4-9.43l0,0v-.21h0s.19-2.58.46-5.66S212.79,336,212.9,327a71.28,71.28,0,0,0-1.07-10.64l3.54-32.87s1.86,23.64,3.11,33.62c1.1,8.67,5.79,34.22,8.41,45.74a56.8,56.8,0,0,1,1.39,13.19v0c0,1.28-.43,11.5,0,14.39.81,6,6.17,5.49,7.22.68.9-4.1.94-13.51,1-15.08,0-1.13.09-2.4.16-3.74C236.68,371.51,239.24,341.38,238.14,330Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "213.526px 317.742px"
    },
    id: "elt7jj1hy2v7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.05,240.67s-1.93,8.12-3.17,18.12-3.43,38-3.14,47,2,30.18,2,30.18,1.83,2.13,7.87,2.37,7.75-2,7.75-2,1-7.32,1-11a46.34,46.34,0,0,0-1.13-9.3l3.34-31.24s1.21,20.46,2.52,31.49,3.75,22.79,3.75,22.79,1.83,2.36,9.23,2,7.93-3.59,7.93-3.59.24-13.65-2.86-23.2c0,0,2-28,2.43-35s1.71-23.15-5.06-33.14S224.29,236,224.29,236Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "216.859px 288.559px"
    },
    id: "el1i7nbl4dll",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj3zob3fuy3c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M215.48,284.89l-1-17.87s-6.75-2.89-9.31-5.88c0,0,1.91,4.14,7.79,7.13l1.2,17.21L213,308.08Z",
    style: {
      opacity: 0.15,
      transformOrigin: "210.325px 284.61px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.35,204.92l3.68.67c-2.05,10,4.67,18.71,4.67,18.71l-2.42,16.37a23.75,23.75,0,0,1,3.14,5.48c-5.79,7.22-25.42,8.74-34,1.93a69.26,69.26,0,0,1,1.37-7.55L199.38,231c-5-5.9-2.86-10.82-1.33-13.75A44.91,44.91,0,0,1,208,203.78l4.55-.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "214.839px 228.043px"
    },
    id: "elddhlrqifvq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.27,205.45c5.68.69,8,5.41,10.84,10.08,2.51,4.09,5,9.14,7.83,13.12,2.57-4.37,8.41-11.52,10.51-15.06s1.52-5.42,2.32-7.77a25.37,25.37,0,0,0,1.44-6.82c.23-2.39,2.24-.83,2.49,1,.18,1.43-1,4.07.45,3.63s3.33-5.74,3.69-7.25,1.32-3.28,2.65-2.49c.53.32.43,1,.35,2.08,1.17,0,2.17.6,2.83,3.41a14,14,0,0,1-1.18,10.12c-2,3.7-2.81,3.53-6.51,8.69s-10.2,18.89-15.14,24.85c-3.11,3.75-5.54,3.47-8.72-.23-3.89-4.51-7.5-11-11.44-16.42S223.52,211.49,227.27,205.45Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "249.235px 219.709px"
    },
    id: "el9bzq90pyly",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.38,173.76c-1.74,1.59-3.9,5-3.73,15.14.15,8.56,2.8,10.69,4.13,11.3s3.92.26,6.43-.16v4.4s-4.38,4.4-4.17,6.75,5.86,3.46,9.11,1.17a27,27,0,0,0,5.9-6.29l.12-12.27s1.46,1.5,4-.76c2.07-1.87,2.79-5,1.18-6.75a3.53,3.53,0,0,0-5.73,1.16,25.8,25.8,0,0,1-10.39-3.12C207.16,181.5,205.93,177,205.38,173.76Z",
    style: {
      fill: "rgb(255, 189, 167)",
      transformOrigin: "215.435px 193.688px"
    },
    id: "el0um5rtr81j6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.51,186.14a1.06,1.06,0,0,1-1,1.13,1.07,1.07,0,0,1-1.09-1,1,1,0,1,1,2.07-.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.466px 186.226px"
    },
    id: "elf7wc53mhq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.28,186.38a1,1,0,1,1-1.09-1A1,1,0,0,1,214.28,186.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "213.28px 186.376px"
    },
    id: "eldh24v6tbjhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,194.32l-2.4.78a1.24,1.24,0,0,0,1.56.91A1.38,1.38,0,0,0,211.54,194.32Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "210.369px 195.19px"
    },
    id: "el8ppcczwxfqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.72,183.19l2.1-1.5a1.2,1.2,0,0,0-1.74-.38A1.44,1.44,0,0,0,202.72,183.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "203.668px 182.138px"
    },
    id: "elaindiip8hk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.59,186.43l0,3.62a1.7,1.7,0,0,1-1.76-1.73A1.87,1.87,0,0,1,222.59,186.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "221.71px 188.241px"
    },
    id: "eloz4o1dys0hf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.75 185.36 208.78 192.37 205.51 191.3 208.75 185.36",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "207.145px 188.865px"
    },
    id: "elwb4lef45hi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.11,185.75h-6.93a3.3,3.3,0,0,0-3.22-2.62h-.51a3.3,3.3,0,0,0-3,2,2.85,2.85,0,0,0-1.93-.83,2.43,2.43,0,0,0-1.7.5,3.29,3.29,0,0,0-2.87-1.71h-.51a3.3,3.3,0,0,0,0,6.6h.51a3.25,3.25,0,0,0,3.11-4.35,1.84,1.84,0,0,1,1.43-.49,2.2,2.2,0,0,1,1.75.89l0,0a3,3,0,0,0-.07.67,3.3,3.3,0,0,0,3.3,3.3H214a3.3,3.3,0,0,0,3.3-3.3s0-.08,0-.12h6.18A6,6,0,0,1,224.11,185.75Zm-20.21,3.42h-.51a2.74,2.74,0,1,1,0-5.48h.51a2.74,2.74,0,0,1,0,5.48Zm10.06,0h-.51a2.74,2.74,0,1,1,0-5.48H214a2.74,2.74,0,0,1,0,5.48Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "212.125px 186.4px"
    },
    id: "elt4dudhqc9k8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.21,200c2.65-.34,8.09-1.94,8.95-4.17a5.83,5.83,0,0,1-1.92,2.84c-1.63,1.44-7,3.06-7,3.06Z",
    style: {
      fill: "rgb(240, 153, 122)",
      transformOrigin: "216.685px 198.78px"
    },
    id: "elmtcxie9nv2i",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kid--inject-12",
    className: "animable",
    style: {
      transformOrigin: "102.517px 307.362px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.35,310.17l-33,.76c-.8,15.25-1.47,37.76-1.47,37.76-.17,2-2,5.44-2.2,13.08-.3,11.78.06,22.41,0,25.1h0l-.18,4.85h0v.18l0,0c.18,2.26,7.51,4.63,7.51,3.17,0,0-1-1.64.53-9,1-5.18,6.36-23.55,8.52-33.84,1.74-8.31,4.38-22.25,4.38-22.25l3,18a61.9,61.9,0,0,0-.12,10.9c1,8.07,2.6,19.51,2.77,24-.45,5.85,4.17,5.08,7.5,4.46,0,0,0-.5.07-1.79l.1-2.63c.56-6.18,2.69-29.86,3.17-36.33C117.9,334.09,116.4,319.82,116.35,310.17Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "98.3779px 352.845px"
    },
    id: "el6e4mu3fuk5u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.32,310.17s-.65,8.69-.87,13.79-.73,23.24-1.31,25.35a54,54,0,0,0-2,12.17s5.61,5,14.86,2.77c-.07-.37,2.41-8.38,3.43-13.84s2.76-15.67,2.76-15.67,2,11.44,2.12,13.63-.8,8.3,0,15.37a17.77,17.77,0,0,0,8.08,1.09c4.3-.51,6-2.77,6-2.77s1-14.2,1.24-19.67-.48-25.11-1.22-32.22Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "98.4085px 337.542px"
    },
    id: "elrc6kgu5hq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.15,334.74l.88-5.45s7.26-.59,10.45-4.22c0,0-1.06,4.76-8.67,5.51l-1,5.27.29,11.32C101.57,343.21,100.9,339,100.15,334.74Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "105.815px 336.12px"
    },
    id: "elblusxtq98oi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,396.67c-.38.13-.17,1.32,0,1.7a4.12,4.12,0,0,0,2.08,1.57,6,6,0,0,1,3.31,2.51,6.81,6.81,0,0,0,3.83,4.08,11.2,11.2,0,0,0,7.66.76c2.15-.63,2.83-1.7,3-2.25a12.83,12.83,0,0,0,0-2.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "88.3376px 402.157px"
    },
    id: "eln2n1et6iokr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.51,399c-1.42-.6-2.2-.87-3-1.93-.21-2.54.56-3.23.48-4.63-.17-2.75.22-2.56.54-2.43,0,.34,0,1.07,0,1.07a3.58,3.58,0,0,0,.92,1.31,2.1,2.1,0,0,0,1.35.22,1.05,1.05,0,0,0,.54-.18,1.48,1.48,0,0,0,.36-.49,4.35,4.35,0,0,1,1.11-1.44,4.46,4.46,0,0,1,3.62-.77,1,1,0,0,1,.42.13c.3.2.26.64.34,1,.32,1.5,1.73,3.16,3,4.45a16.14,16.14,0,0,0,2.88,2.47,13.87,13.87,0,0,1,3,2.23,4.26,4.26,0,0,1,.94,3.81,3.25,3.25,0,0,1-2.15,2,9.08,9.08,0,0,1-2.82.57,9.3,9.3,0,0,1-3.62-.51,7.59,7.59,0,0,1-4.38-3.46A7.39,7.39,0,0,0,81.51,399Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "88.3012px 398.015px"
    },
    id: "el7ozuucnanut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elotd9otig41h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.51,399c-1.42-.6-2.2-.87-3-1.93-.21-2.54.56-3.23.48-4.63-.17-2.75.22-2.56.54-2.43,0,.34,0,1.07,0,1.07a3.58,3.58,0,0,0,.92,1.31,2.1,2.1,0,0,0,1.35.22,1.05,1.05,0,0,0,.54-.18,1.48,1.48,0,0,0,.36-.49,4.35,4.35,0,0,1,1.11-1.44,4.46,4.46,0,0,1,3.62-.77,1,1,0,0,1,.42.13c.3.2.26.64.34,1,.32,1.5,1.73,3.16,3,4.45a16.14,16.14,0,0,0,2.88,2.47,13.87,13.87,0,0,1,3,2.23,4.26,4.26,0,0,1,.94,3.81,3.25,3.25,0,0,1-2.15,2,9.08,9.08,0,0,1-2.82.57,9.3,9.3,0,0,1-3.62-.51,7.59,7.59,0,0,1-4.38-3.46A7.39,7.39,0,0,0,81.51,399Z",
    style: {
      opacity: 0.5,
      transformOrigin: "88.3012px 398.015px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85,394.21a5.58,5.58,0,0,1,4.08-1.35.82.82,0,0,1,.64.86,6.1,6.1,0,0,0-4.34,1.42c-.27.22-.51.25-.73,0S84.8,394.4,85,394.21Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "87.1523px 394.08px"
    },
    id: "el2fbdr1n7x0d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,396.07a6.14,6.14,0,0,1,4.31-1.44s.89.24.9.92c0,0-2-.53-4.58,1.39a.54.54,0,0,1-.88-.18h0A.66.66,0,0,1,86.23,396.07Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "88.7004px 395.858px"
    },
    id: "elxzqh15fexub",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.78,398.74a.62.62,0,0,1,.13-.8,6.24,6.24,0,0,1,4.27-1.59s1.07.29,1.21,1a6.75,6.75,0,0,0-4.69,1.54.62.62,0,0,1-.91-.1Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "90.5391px 397.697px"
    },
    id: "elxtedpxz9at",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.06,401.27a4.73,4.73,0,0,0-1.2,3.92,7.09,7.09,0,0,0,1.62.72,9.3,9.3,0,0,0,3.62.51,9.08,9.08,0,0,0,2.82-.57c.92-.34,2.23-1,2.54-2.08a4.78,4.78,0,0,0-1.08-4,3.56,3.56,0,0,0-1.44-.93h0C94,398.2,90.73,399.36,89.06,401.27Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "93.1736px 402.549px"
    },
    id: "elmckulmc8g6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,388.58c-.38.13-.17,1.32,0,1.7a4.16,4.16,0,0,0,2.09,1.57c1,.34,2.76,1.27,3.31,2.51a6.81,6.81,0,0,0,3.82,4.08,11.21,11.21,0,0,0,7.66.76c2.16-.64,2.84-1.7,3-2.26a13.94,13.94,0,0,0,0-2.23Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "114.856px 394.066px"
    },
    id: "elc85b0px71fj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.07,390.93c-1.41-.6-2.19-.87-3-1.94-.21-2.53.56-3.22.47-4.62-.17-2.75.22-2.56.55-2.43,0,.33,0,1.07,0,1.07a3.66,3.66,0,0,0,.92,1.31,2.07,2.07,0,0,0,1.34.22,1.12,1.12,0,0,0,.54-.18,1.36,1.36,0,0,0,.36-.49,4.28,4.28,0,0,1,1.12-1.44,4.48,4.48,0,0,1,3.61-.78,1.09,1.09,0,0,1,.43.14c.3.2.26.63.33,1,.32,1.5,1.73,3.16,3,4.45a16.09,16.09,0,0,0,2.88,2.46,14,14,0,0,1,3,2.23,4.28,4.28,0,0,1,1,3.81,3.29,3.29,0,0,1-2.16,2,9,9,0,0,1-2.82.57,9.34,9.34,0,0,1-3.62-.52,7.57,7.57,0,0,1-4.38-3.45A7.31,7.31,0,0,0,108.07,390.93Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "114.879px 389.937px"
    },
    id: "el8m7f11575j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpxuvm0ve9tl"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.07,390.93c-1.41-.6-2.19-.87-3-1.94-.21-2.53.56-3.22.47-4.62-.17-2.75.22-2.56.55-2.43,0,.33,0,1.07,0,1.07a3.66,3.66,0,0,0,.92,1.31,2.07,2.07,0,0,0,1.34.22,1.12,1.12,0,0,0,.54-.18,1.36,1.36,0,0,0,.36-.49,4.28,4.28,0,0,1,1.12-1.44,4.48,4.48,0,0,1,3.61-.78,1.09,1.09,0,0,1,.43.14c.3.2.26.63.33,1,.32,1.5,1.73,3.16,3,4.45a16.09,16.09,0,0,0,2.88,2.46,14,14,0,0,1,3,2.23,4.28,4.28,0,0,1,1,3.81,3.29,3.29,0,0,1-2.16,2,9,9,0,0,1-2.82.57,9.34,9.34,0,0,1-3.62-.52,7.57,7.57,0,0,1-4.38-3.45A7.31,7.31,0,0,0,108.07,390.93Z",
    style: {
      opacity: 0.5,
      transformOrigin: "114.879px 389.937px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.6,386.11a5.54,5.54,0,0,1,4.07-1.34.82.82,0,0,1,.64.86,6.1,6.1,0,0,0-4.34,1.42c-.27.22-.5.24-.73-.05S111.36,386.31,111.6,386.11Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "113.739px 385.985px"
    },
    id: "elqge1doic2d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.79,388a6.18,6.18,0,0,1,4.31-1.44s.89.23.91.92c0,0-2-.53-4.58,1.39a.55.55,0,0,1-.89-.19h0A.65.65,0,0,1,112.79,388Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "115.266px 387.787px"
    },
    id: "elpyb0ukwetac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.34,390.64a.62.62,0,0,1,.14-.8,6.24,6.24,0,0,1,4.27-1.58s1.06.28,1.21.95a6.78,6.78,0,0,0-4.69,1.55.62.62,0,0,1-.91-.1Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "117.106px 389.587px"
    },
    id: "elpr1o13amli9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.63,393.17a4.74,4.74,0,0,0-1.21,3.93,7.25,7.25,0,0,0,1.62.71,9.34,9.34,0,0,0,3.62.52,9,9,0,0,0,2.82-.57c.93-.35,2.23-1,2.54-2.09a4.76,4.76,0,0,0-1.07-4,3.43,3.43,0,0,0-1.44-.93h0C120.57,390.11,117.29,391.26,115.63,393.17Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "119.736px 394.455px"
    },
    id: "elf137lrp54c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.86,280l8.47,10.28,13.09-8.59,3.37,7.13a117.13,117.13,0,0,1-12.36,9.71c-2,1.28-6.27,4.77-9,2a69.41,69.41,0,0,1-5.84-7.21Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "129.19px 290.786px"
    },
    id: "el2ihm8ajvizy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,281.69l-6.81,4.47a7.07,7.07,0,0,0,6.14,6.14c2.37-2,4-3.48,4-3.48Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "137.68px 286.995px"
    },
    id: "elew7qm5j050i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.44,271.84c5.45-.35,9.93,3.66,12.92,7.5,3.29,4.21,7.81,10.63,7.81,10.63a13.09,13.09,0,0,1-6.78,9.1l-11.78-13.69Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "115.805px 285.444px"
    },
    id: "el9e4ahfxw3lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.23,272.87c-1.71,2.92-1.8,3.52-2.2,6.7-.18,1.47-2.24,4.94-2.24,6.89l1.61,13-.62,16.38c4.74,5.15,23.82,6.8,34.15-.75,0,0-1.09-26.6-1.87-31.8-1.34-9-6.19-11.79-10.53-11.46l-11.45.55Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "99.36px 296.019px"
    },
    id: "elr29maq1pn0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.08,274.41c-1.86-.67-4.21.93-7.47,5-2.9,3.58-6.1,7.73-6.1,7.73S66,275.33,66,273.59s.35-1.86.5-4.09-.08-3.72.38-4.69-1.41-1-2.06.18-.59,2.84-1.13,2.59-1.2-3.69-1-6.23-1.23-3.08-1.68-2.24a7.23,7.23,0,0,0-.6,1.41,3.25,3.25,0,0,0-3.21,1c-1.17,1.55-2.15,3.78-1.83,7.5s2.43,6.28,2.83,7.94,4,15.6,8.13,22.28c1.87,3.05,4.94,2.79,7.06.67,2.85-2.86,9.78-9.95,9.78-9.95C87.24,284,88.28,277.57,85.08,274.41Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "71.1355px 280.13px"
    },
    id: "eliuob1j1c2dj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.64,272.85c-.61,0-4,.07-6,2.18a87.82,87.82,0,0,0-9,11.54s4.72,5.27,4.09,11.93l9-8.6A20.61,20.61,0,0,0,86.64,272.85Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "79.6558px 285.675px"
    },
    id: "elpgetj9ljden",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5d6y7n57x4i"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 106.33,
    cy: 251.86,
    r: 9.73,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "106.33px 251.86px",
      transform: "rotate(-76.72deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.08,258s1.52,7.13,2.13,8.3a3.26,3.26,0,0,0,1.87,1.51l-.11-5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.08px 262.905px"
    },
    id: "ellt6nxm88c6l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,247.76a3.52,3.52,0,0,0-2.91,1c-1.25,1.28-.55,5.28,1,9.19l2.86.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.6984px 253.007px"
    },
    id: "elu7izjy016zc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,258.3c-.57.35-1.39-.75-2.1-1.49a2.48,2.48,0,0,0-4.16.67c-1.17,2.47,1,5.74,2.83,6.31,3.13,1,3.6-1,3.6-1l.24,11.29a10.07,10.07,0,0,0,7.6,5.77c5.55.75,5.49-3.9,3.67-6.14v-3.17a13.46,13.46,0,0,0,4.1-.41c1.77-.48,3.11-1.54,4.28-4.23,1.56-3.61,1.76-7.57.61-15-1.33-8.59-11.9-8.84-17.32-5.43S92.8,258.3,92.8,258.3Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "100.207px 261.678px"
    },
    id: "el6nvsira11b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8,259.27c-.29,0-1.38-1.81-2.1-2.46-1-.9.29-9.05.29-9.05a3.86,3.86,0,0,1,1-4.12c1.36-1.49,3.62-1.65,7.48-2.26,2-.32,5.1-.89,7.13-1.26,2.41-.45,4.42-.93,6.12.56a4.29,4.29,0,0,1,1.19,4.8,3.9,3.9,0,0,1-.69,1,4,4,0,0,1-1.74,1.2s-1.05.94-4.72,1.38a53.66,53.66,0,0,1-10.16-.19c-1.06-.15-1.29.88-1.86,3.7C94.19,255.06,93.77,259.25,92.8,259.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.261px 249.471px"
    },
    id: "elvt3n1qm0kq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,248.4l-3.46-1.86a1.9,1.9,0,0,1,2.62-.87A2.05,2.05,0,0,1,91,248.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.3822px 246.922px"
    },
    id: "el9jhlzz24gg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48,270.51s-5.53-.57-8-2.18A7,7,0,0,1,94,265.87a6.85,6.85,0,0,0,1.41,2.9c2.47,2.92,9.1,3.09,9.1,3.09Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "99.255px 268.865px"
    },
    id: "el5m610o4l8w6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.53,257a1.16,1.16,0,1,1-1.16-1.21A1.18,1.18,0,0,1,102.53,257Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "101.371px 256.95px"
    },
    id: "el8tqc3wdfs4n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,253.54l-2.47,1.36a1.47,1.47,0,0,1,.58-2A1.37,1.37,0,0,1,101,253.54Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "99.6733px 253.82px"
    },
    id: "elxusu4zx8gng",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.54,263.82l3.15,1.18a1.65,1.65,0,0,1-2.14,1.05A1.76,1.76,0,0,1,102.54,263.82Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "104.064px 264.985px"
    },
    id: "elwrlivrd59k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.45,254.18l-2.25-1.73a1.35,1.35,0,0,1,2-.3A1.48,1.48,0,0,1,112.45,254.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "111.472px 253.007px"
    },
    id: "eli5g0h7scwp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.86,256.5a1.16,1.16,0,1,1-1.16-1.21A1.18,1.18,0,0,1,111.86,256.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "110.701px 256.45px"
    },
    id: "elgudq6tsy1jb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.7 255.75 106.04 261.94 109.28 260.84 105.7 255.75",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "107.49px 258.845px"
    },
    id: "elm6s7osb7c2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.17,268.86a62.07,62.07,0,0,0,2.14,10.9c2.94,8.46,5.42,11.21,9.26,11.47,6.12.41,6.16-1.89,3.41-5.83a19.56,19.56,0,0,1-2.73-5.64,14.25,14.25,0,0,0,2.94,1.89,2.11,2.11,0,0,0,2.76-.74c.2-.42-.86-.83-2-2.26-1.5-1.83-2.27-3.29-4.33-4.8a4.26,4.26,0,0,1-1.24-2.53c-.31-1.23-.53-20.9.58-25l5.27-18.91c4.29-2.94,7.19-17.23.67-20.33-8.26.9-10,4.6-17,34C127.86,245.5,127.86,257.7,129.17,268.86Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "138.938px 249.178px"
    },
    id: "elr19ja5atn3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.25,279.76c-3.26-.05-5.05,2.91-3,5.3S145,287,145,287l.42.85c.68-.34,1.6-1.44.93-3.32C145.56,282.38,144.17,279.8,141.25,279.76Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "141.98px 283.805px"
    },
    id: "elqwe3pawh6lr",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--boy-with-wheelchair--inject-12",
    className: "animable",
    style: {
      transformOrigin: "349.7px 326.933px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-12",
    className: "animable",
    style: {
      transformOrigin: "349.7px 326.933px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.87,352.36V356a18.8,18.8,0,0,0,2.79,9.88l.42.65.05.07c.12.19.25.37.38.54a18.89,18.89,0,0,0,13.19,7.65l.15,0,.28,0,.56,0h.21l.65,0h.23a23.08,23.08,0,0,0,11-3.43l1.6-.93c13.92-8,25.2-27.57,25.2-43.65v-1.85c0-.36,0-.71,0-1.06v-.75a18.89,18.89,0,0,0-2.28-9l0,0-.18-.35c-.06-.08-.1-.17-.15-.25-.13-.24-.28-.47-.42-.7l-.24-.35-.2-.27a4,4,0,0,0-.31-.41l-.18-.22a18.86,18.86,0,0,0-12.9-7.2,13.94,13.94,0,0,0-1.72-.1h-.29a22.83,22.83,0,0,0-11,3.43l-1.61.93C326.15,316.75,314.87,336.29,314.87,352.36Zm9.45.93c0-13.57,9.53-30.06,21.28-36.85s21.28-1.29,21.28,12.29-9.53,30.06-21.28,36.84S324.32,366.86,324.32,353.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "343.225px 339.53px"
    },
    id: "elbxdagdyrp2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.6,355.09V357c0,7.95,2.76,13.55,7.23,16.22l.22.13a.46.46,0,0,0,.14.07l.09.06.35.18a7.84,7.84,0,0,0,.72.32l.33.14.41.15.36.11a8.31,8.31,0,0,0,.89.25l.47.1.49.08.55.08.28,0,.56,0h.21l.65,0a22.9,22.9,0,0,0,11.25-3.44l1.6-.93c13.92-8,25.2-27.57,25.2-43.65v-1.85c0-.36,0-.71,0-1.06s0-.59,0-.87v-.32c0-.26,0-.51-.07-.77,0-.05,0-.1,0-.14,0-.31-.07-.6-.11-.89s-.07-.52-.12-.78-.05-.3-.07-.45c-.06-.31-.12-.63-.19-.93l-.2-.8c-.13-.48-.27-.95-.43-1.4,0,0,0,0,0,0-.08-.25-.17-.5-.27-.74-.18-.46-.37-.9-.58-1.33l-.18-.35-.18-.35c-.06-.08-.1-.17-.15-.25-.13-.24-.28-.47-.42-.7l-.24-.35-.2-.27a4,4,0,0,0-.31-.41c-.1-.14-.21-.26-.32-.39a3.9,3.9,0,0,0-.33-.38,9.25,9.25,0,0,0-.7-.7l-.36-.33a8.82,8.82,0,0,0-.76-.61c-.13-.09-.26-.19-.4-.27s-.27-.18-.41-.27l-.08-.05-.35-.21c-4.55-2.54-10.79-2.13-17.68,1.85l-1.6.93C330.88,319.48,319.6,339,319.6,355.09Zm4.72-1.8c0-13.57,9.53-30.06,21.28-36.85s21.28-1.29,21.28,12.29-9.53,30.06-21.28,36.84S324.32,366.86,324.32,353.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "345.6px 340.973px"
    },
    id: "elmg3riq668oe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.78,362.09c3.36,4,9.19,4.58,15.82.76,10.45-6,18.91-20.7,18.91-32.76,0-5.39-1.69-9.35-4.49-11.54,2,2.31,3.09,5.76,3.09,10.18,0,12-8.47,26.72-18.92,32.75C338.42,364.82,333.25,364.81,329.78,362.09Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "347.145px 341.987px"
    },
    id: "elc8ojh91qq3e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnm2b1sgkhr9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.78,362.09c3.36,4,9.19,4.58,15.82.76,10.45-6,18.91-20.7,18.91-32.76,0-5.39-1.69-9.35-4.49-11.54,2,2.31,3.09,5.76,3.09,10.18,0,12-8.47,26.72-18.92,32.75C338.42,364.82,333.25,364.81,329.78,362.09Z",
    style: {
      opacity: 0.2,
      transformOrigin: "347.145px 341.987px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.33,353.29c0,13.57,9.52,19.07,21.27,12.28s21.28-23.28,21.28-36.85-9.53-19.06-21.28-12.28S324.33,339.72,324.33,353.29Zm2.36-1.36c0-12.06,8.47-26.73,18.91-32.76s18.91-1.14,18.91,10.92-8.46,26.72-18.91,32.75S326.69,364,326.69,351.93Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "345.605px 341.007px"
    },
    id: "ele8dooe8vqdq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.33,345.93c0-.22.09-.43.14-.64l16.47-4.42.37-.55-12.1-7c.09-.17.19-.33.29-.5l12.11,7,.29-.6-4.38-16.32.49-.43,4.3,16,.58-.67,4.23-20.66.63-.17-4.17,20.39.66-.1,11.35-19.66c.17.09.35.18.51.28L347.74,337.6l.25.62,15.73-13.94c.06.2.12.4.17.62L347.94,339l-.28.83L364,335.5c0,.21-.08.42-.13.64l-16.6,4.44-.37.55,12.34,7.13c-.09.17-.18.34-.28.51l-12.35-7.13-.29.6L350.8,359c-.16.15-.32.3-.49.44l-4.42-16.5-.58.66L341,364.86l-.63.16,4.29-21-.66.1-11.6,20.09-.49-.3,11.59-20.08-.25-.62-15.85,14.05c-.06-.2-.11-.42-.16-.63l16.06-14.24.28-.84Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "345.62px 340.995px"
    },
    id: "elyoj6nn9raps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.41,344.48c0,2.22.77,3.79,2,4.54.39.24.69.39,1,.59a3.77,3.77,0,0,0,2.31.54h0l.51-.08.16,0,.4-.11.29-.08.28-.12c.14-.05.28-.1.43-.17s.48-.23.72-.37a15.68,15.68,0,0,0,7.09-12.29q0-.41,0-.78a2.51,2.51,0,0,0,0-.27,3.62,3.62,0,0,0-.06-.46c0-.1-.05-.2-.07-.31l-.09-.34c0-.12-.08-.22-.12-.33a2,2,0,0,0-.1-.26c-.05-.12-.11-.23-.16-.33l-.11-.19a3.78,3.78,0,0,0-.22-.33l-.09-.12a2.8,2.8,0,0,0-.28-.31l-.08-.08a3,3,0,0,0-.34-.28l0,0-.05,0-.27-.18c-.35-.2-.67-.35-.94-.51-1.29-.81-3.1-.74-5.11.42A15.67,15.67,0,0,0,337.41,344.48Zm8.9,1.48c-.58-1.14-.7-3.38,0-4.23s.71.39,2.55-.56a12,12,0,0,0,1.24-.76,17.37,17.37,0,0,1-3.59,5.42A.71.71,0,0,1,346.31,346Zm-4.26-8.73a.74.74,0,0,1,.07-.21,12,12,0,0,1,4.64-3.6,9.88,9.88,0,0,1-1.89,5.3,1.39,1.39,0,0,0-.54-.54l-1.09-.62a2.08,2.08,0,0,0-.3-.13A4.5,4.5,0,0,0,342.05,337.23Zm7.31-4.09a5.34,5.34,0,0,1,1.22,3.59c-.15,1.35-2.42,2.7-3.81,2.93.06-.7,1-1,1.55-3.17C348.81,334.73,348.77,333.39,349.36,333.14Zm-8.49,15-.07-.09c-.56-.89,1.62-3.91,3.07-5a3.69,3.69,0,0,0,0,2c.38,1.4,1.2,2.06.46,2.73A4.67,4.67,0,0,1,340.87,348.11Zm-1.44-2.93a13.58,13.58,0,0,1,1.21-5.29,1.83,1.83,0,0,1,2.23-.75,1.42,1.42,0,0,1,.5,1.48c-.37,1.1-1,.39-2.52,2.45C340.26,343.85,339.8,344.63,339.43,345.18Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.007px 340.738px"
    },
    id: "elk23njeh102j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3zulcinvxuw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.41,344.48c0,2.22.77,3.79,2,4.54.39.24.69.39,1,.59a3.77,3.77,0,0,0,2.31.54h0l.51-.08.16,0,.4-.11.29-.08.28-.12c.14-.05.28-.1.43-.17s.48-.23.72-.37a15.68,15.68,0,0,0,7.09-12.29q0-.41,0-.78a2.51,2.51,0,0,0,0-.27,3.62,3.62,0,0,0-.06-.46c0-.1-.05-.2-.07-.31l-.09-.34c0-.12-.08-.22-.12-.33a2,2,0,0,0-.1-.26c-.05-.12-.11-.23-.16-.33l-.11-.19a3.78,3.78,0,0,0-.22-.33l-.09-.12a2.8,2.8,0,0,0-.28-.31l-.08-.08a3,3,0,0,0-.34-.28l0,0-.05,0-.27-.18c-.35-.2-.67-.35-.94-.51-1.29-.81-3.1-.74-5.11.42A15.67,15.67,0,0,0,337.41,344.48Zm8.9,1.48c-.58-1.14-.7-3.38,0-4.23s.71.39,2.55-.56a12,12,0,0,0,1.24-.76,17.37,17.37,0,0,1-3.59,5.42A.71.71,0,0,1,346.31,346Zm-4.26-8.73a.74.74,0,0,1,.07-.21,12,12,0,0,1,4.64-3.6,9.88,9.88,0,0,1-1.89,5.3,1.39,1.39,0,0,0-.54-.54l-1.09-.62a2.08,2.08,0,0,0-.3-.13A4.5,4.5,0,0,0,342.05,337.23Zm7.31-4.09a5.34,5.34,0,0,1,1.22,3.59c-.15,1.35-2.42,2.7-3.81,2.93.06-.7,1-1,1.55-3.17C348.81,334.73,348.77,333.39,349.36,333.14Zm-8.49,15-.07-.09c-.56-.89,1.62-3.91,3.07-5a3.69,3.69,0,0,0,0,2c.38,1.4,1.2,2.06.46,2.73A4.67,4.67,0,0,1,340.87,348.11Zm-1.44-2.93a13.58,13.58,0,0,1,1.21-5.29,1.83,1.83,0,0,1,2.23-.75,1.42,1.42,0,0,1,.5,1.48c-.37,1.1-1,.39-2.52,2.45C340.26,343.85,339.8,344.63,339.43,345.18Z",
    style: {
      opacity: 0.2,
      transformOrigin: "345.007px 340.738px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M338.51,345.1c0,4.52,3.17,6.36,7.09,4.1a15.68,15.68,0,0,0,7.09-12.29c0-4.52-3.17-6.35-7.09-4.09A15.66,15.66,0,0,0,338.51,345.1Zm7.11-5.51c-.85.35-.16-1-1.6-1.55-1.13-.4-2.36,0-1.9-1s3.84-3.7,5.24-3.72S346.85,339.08,345.62,339.59Zm6.05-2.25c-.21,1.91-4.68,3.85-4.89,2.55-.15-.88.88-1,1.54-3.4.52-1.87.43-3.28,1.15-3.41S351.89,335.44,351.67,337.34Zm-5.34,4.39c.75-.9.71.39,2.55-.56,1.45-.75,2.63-2,2.62-1.09s-2.35,5.17-3.88,6.36S345.23,343,346.33,341.73Zm-1.43.82c.61.33-.45,1.29,0,3.06.38,1.41,1.2,2.06.47,2.74s-3.87.83-4.6-.33S344,342.07,344.9,342.55Zm-5.3,3.91c-.44-.47,0-4.65,1-6.57s4.37-.26,3.81,1.34c-.37,1.1-1,.4-2.52,2.45C340.71,345.3,340,346.94,339.6,346.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "345.6px 341.009px"
    },
    id: "eljx6h5a6clb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.6,343.51c-1.2.69-2.17.13-2.17-1.25a4.8,4.8,0,0,1,2.17-3.76c1.2-.69,2.17-.13,2.17,1.26A4.78,4.78,0,0,1,345.6,343.51Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "345.6px 341.005px"
    },
    id: "el6j7skltuifq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.82,355.86a1,1,0,0,0-1.41-.37l-.88.51a21.47,21.47,0,0,0-8.74,9.47l-2.66,5.62h0l-8.36,17.64a1,1,0,0,0,.5,1.38,1.13,1.13,0,0,0,.44.1,1,1,0,0,0,.93-.59l8.21-17.33,10.33-5.86a1,1,0,1,0-1-1.8L299.38,369l1.28-2.69a19.49,19.49,0,0,1,7.9-8.57l.88-.5A1.05,1.05,0,0,0,309.82,355.86Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "298.799px 372.774px"
    },
    id: "elgla6fkgd76h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,365.81c2.93,5.53,2,12.57,1.87,15s1.1,1.93,1.78,0,2.48-9.83-.57-16.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "310.399px 373.27px"
    },
    id: "elqre0sk3jus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,383a15.39,15.39,0,0,1,7-12.07c2-1.17,3.83-1.21,5.11-.36h0l3,1.67-10,17-2.93-1.68h0C303.25,386.83,302.43,385.27,302.43,383Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "309.985px 379.613px"
    },
    id: "elsivvmmx0ktp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,372.73a15.4,15.4,0,0,0-7,12.07c0,4.45,3.12,6.25,7,4a15.42,15.42,0,0,0,7-12.07C319.52,372.31,316.4,370.51,312.55,372.73Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "312.55px 380.774px"
    },
    id: "elw9vzh8go2fn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.55,378a5.42,5.42,0,0,0-2.45,4.25c0,1.56,1.1,2.19,2.45,1.41a5.41,5.41,0,0,0,2.46-4.25C315,377.8,313.91,377.16,312.55,378Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.555px 380.812px"
    },
    id: "elnejuadfwlsa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.1,365.58c2.92,5.53,2,12.57,1.87,15s1.1,1.93,1.78,0,2.48-9.83-.58-16.72Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "312.499px 373.04px"
    },
    id: "eldwag448kbi7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.01 368.8 331.88 354.09 331.88 351.01 309.49 364.3 307.01 368.8",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "319.445px 359.905px"
    },
    id: "ell8cw5c5yaro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.55 419.61 336.54 411.54 291.79 385.69 277.8 393.77 322.55 419.61",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "307.17px 402.65px"
    },
    id: "elmq9syijkx1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.54 411.54 336.54 414.77 322.55 422.84 322.55 419.61 336.54 411.54",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "329.545px 417.19px"
    },
    id: "el714o5h83gki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elunwao50ctff"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "336.54 411.54 336.54 414.77 322.55 422.84 322.55 419.61 336.54 411.54",
    style: {
      opacity: 0.3,
      transformOrigin: "329.545px 417.19px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "277.8 393.77 277.8 397 322.55 422.84 322.55 419.61 277.8 393.77",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "300.175px 408.305px"
    },
    id: "eldfk56c8nfgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1avyg3e1x69h"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "277.8 393.77 277.8 397 322.55 422.84 322.55 419.61 277.8 393.77",
    style: {
      opacity: 0.15,
      transformOrigin: "300.175px 408.305px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.07,381.46a1,1,0,0,0-1.41-.38l-.88.51a21.52,21.52,0,0,0-8.74,9.47l-2.66,5.63h0L333,414.32a1,1,0,0,0,.49,1.38,1,1,0,0,0,.44.1,1,1,0,0,0,.93-.59l8.22-17.33L353.42,392a1,1,0,1,0-1-1.79l-7.76,4.4,1.27-2.69a19.52,19.52,0,0,1,7.9-8.56l.88-.51A1,1,0,0,0,355.07,381.46Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "344.051px 398.365px"
    },
    id: "elaaxs1a7s7lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.59,393.12c2.92,5.53,2,12.57,1.87,15s1.09,1.93,1.77,0,2.48-9.83-.57-16.72Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "357.984px 400.58px"
    },
    id: "elkda3tjacxqa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,410.3a15.42,15.42,0,0,1,7-12.07c2-1.16,3.84-1.21,5.11-.36h0l3,1.68-10,17-2.94-1.67v0C350.8,414.14,350,412.57,350,410.3Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "357.555px 406.919px"
    },
    id: "elb88jswgzm2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,400a15.39,15.39,0,0,0-7,12.07c0,4.44,3.12,6.24,7,4a15.42,15.42,0,0,0,7-12.07C367.07,399.61,364,397.81,360.11,400Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "360.11px 408.05px"
    },
    id: "elx3cq2qkj4ie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.11,405.25a5.41,5.41,0,0,0-2.46,4.25c0,1.56,1.1,2.2,2.46,1.42a5.45,5.45,0,0,0,2.45-4.25C362.56,405.1,361.46,404.47,360.11,405.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "360.105px 408.084px"
    },
    id: "el9v9pa8tfm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,392.89c2.92,5.53,2,12.57,1.87,15s1.1,1.94,1.78,0,2.48-9.83-.58-16.72Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "360.049px 400.352px"
    },
    id: "elaxkvvs8lp37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.47,296.16l-3.61-6.24,15.26-8.81h0a1.76,1.76,0,0,1,1.83.15,5.67,5.67,0,0,1,2.55,4.42,1.81,1.81,0,0,1-.72,1.62h0l0,0h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "411.684px 288.541px"
    },
    id: "elestrbp3c3nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.21,294.51c0,1.63-1.14,2.29-2.55,1.47a5.61,5.61,0,0,1-2.55-4.41c0-1.62,1.14-2.28,2.55-1.47A5.62,5.62,0,0,1,406.21,294.51Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "403.66px 293.043px"
    },
    id: "elfiqadbxmn7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.53,291.54a.92.92,0,0,0-.76-.13l-.2.13-10.65,6.14.23.17.71.51c.53.37,1.05.75,1.54,1.17a5.18,5.18,0,0,1,.41.4l9.37-5.41.38-.22a.94.94,0,0,0,.19-.64A2.72,2.72,0,0,0,403.53,291.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.336px 295.654px"
    },
    id: "elu5wag6wz04j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,275.54l-3.61-6.23,15.27-8.82h0a1.75,1.75,0,0,1,1.82.16,5.62,5.62,0,0,1,2.55,4.41,1.8,1.8,0,0,1-.71,1.62h0l0,0h0Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "376.445px 267.923px"
    },
    id: "elvp11569jpx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,273.9c0,1.62-1.14,2.28-2.54,1.47a5.64,5.64,0,0,1-2.55-4.42c0-1.62,1.14-2.28,2.55-1.47A5.66,5.66,0,0,1,371,273.9Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "368.455px 272.425px"
    },
    id: "eli3p2jof7k2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.29,270.92a.89.89,0,0,0-.75-.12l-.21.12-10.64,6.14.22.17.71.51a17.59,17.59,0,0,1,1.55,1.18c.14.12.27.26.41.39l9.36-5.41.39-.21a1,1,0,0,0,.19-.65A2.74,2.74,0,0,0,368.29,270.92Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "363.106px 275.037px"
    },
    id: "elatghim55sm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.75,284.8l11.11,6.42-50.45,23.86a12.63,12.63,0,0,0-5.7,8.58l-6.9,44.7a.77.77,0,0,1-1.15.54h0c-.26-.15-.41-.44-.32-1.52l4-47.5a12.26,12.26,0,0,1,4.66-8.05Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "333.587px 326.903px"
    },
    id: "eln4lmpu3ysz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.62,370.27l41.91-24.21a5.86,5.86,0,0,0,2.64-4.59V339a5.86,5.86,0,0,0-2.64-4.59l-41.91-24.19a5.83,5.83,0,0,0-5.3,0l-41.9,24.19a5.87,5.87,0,0,0-2.65,4.59v2.5a5.87,5.87,0,0,0,2.65,4.59l41.9,24.18A5.89,5.89,0,0,0,356.62,370.27Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "353.97px 340.241px"
    },
    id: "el7ra67k6wvy9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkwsksb1f72r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.85,370.6a3.8,3.8,0,0,0,.77-.33l41.91-24.22a5.85,5.85,0,0,0,2.64-4.58V339a6,6,0,0,0-2.15-4.24c.94.84.78,2-.49,2.71l-41.71,24.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "378.51px 352.68px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5tuz9mvu66q"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.77,339v2.5a5.85,5.85,0,0,0,2.65,4.59l41.91,24.18a5.87,5.87,0,0,0,4.52.33l1-9.05-.2.11a5.81,5.81,0,0,1-5.29,0l-41.91-24.19c-1.28-.74-1.44-1.87-.5-2.71A6,6,0,0,0,306.77,339Z",
    style: {
      opacity: 0.15,
      transformOrigin: "331.81px 352.832px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341.71,318.82,383.62,343a5.59,5.59,0,0,0,3.1.61l.47-.05.1,0,.27-.05h0a3.2,3.2,0,0,0,.42-.1,4.87,4.87,0,0,0,.9-.38l2.16-1.25a7.41,7.41,0,0,0,3.18-4.54l6.37-35.57a3.6,3.6,0,0,0,.06-.66c0-.09,0-.18,0-.26a4.53,4.53,0,0,0-.29-1.3,4.66,4.66,0,0,0-1.4-2l-.18-.14a2.2,2.2,0,0,0-.28-.18l-41.91-24.2a5.87,5.87,0,0,0-5.29,0l-2.16,1.25a5.69,5.69,0,0,0-1.27,1,2.25,2.25,0,0,0-.21.24,7.84,7.84,0,0,0-.78,1l-.15.24-.12.21c-.06.11-.11.21-.16.32a2.92,2.92,0,0,0-.14.31c0,.09-.07.18-.11.26l0,.13-.08.23a2.81,2.81,0,0,0-.08.31,1.42,1.42,0,0,0,0,.22l-6.37,35.58A4.64,4.64,0,0,0,341.71,318.82Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "370.133px 307.967px"
    },
    id: "elo82t5kspih8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.18,306l-6.37,35.58a2,2,0,0,1-3.19,1.48l-41.91-24.2a4.65,4.65,0,0,1-2.1-4.54L346,278.71a2,2,0,0,1,3.19-1.48l41.9,24.19A4.66,4.66,0,0,1,393.18,306Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "366.398px 310.145px"
    },
    id: "ela2goz4dlfab",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0o2xzk7zt19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.18,306l-6.37,35.58a2,2,0,0,1-3.19,1.48l-41.91-24.2a4.65,4.65,0,0,1-2.1-4.54L346,278.71a2,2,0,0,1,3.19-1.48l41.9,24.19A4.66,4.66,0,0,1,393.18,306Z",
    style: {
      opacity: 0.15,
      transformOrigin: "366.398px 310.145px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eligi09ohxbxo"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.7,343.44a5.94,5.94,0,0,0,2,.19l.47-.05.37-.07h0a3.2,3.2,0,0,0,.42-.1,4.87,4.87,0,0,0,.9-.38l2.16-1.25a7.41,7.41,0,0,0,3.18-4.54l6.37-35.57a3.6,3.6,0,0,0,.06-.66c0-.09,0-.18,0-.26a4.53,4.53,0,0,0-.29-1.3l-7.48,4.25a4.17,4.17,0,0,1,.27,2.27l-6.37,35.58a2,2,0,0,1-2.1,1.84A.13.13,0,0,1,384.7,343.44Z",
    style: {
      opacity: 0.3,
      transformOrigin: "392.645px 321.548px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,271.09c-6-2.06-10.25,3.51-16.17,9-4.06,3.77-9.11,9.12-9.11,9.12s-6.69-13-6.93-15c-.28-2.5.68-3.47.86-6.15s-.1-4.48.45-5.65-1.69-1.24-2.47.22-.71,3.42-1.36,3.12-1.45-4.45-1.18-7.51-1.49-3.7-2-2.68a8.25,8.25,0,0,0-.71,1.69,3.93,3.93,0,0,0-3.87,1.25c-1.4,1.85-2.59,4.54-2.2,9s2.93,7.65,3.71,9.54c1.16,2.83,4.53,18.79,9.48,26.83,2.25,3.67,5.68,3.05,8.49.8,4.36-3.5,17.07-14.93,17.07-14.93C351.55,282.47,356.45,274.89,352.6,271.09Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "330.909px 280.8px"
    },
    id: "eld2w6ou5i2po",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,289.2a19.88,19.88,0,0,1,2.06,9,14.45,14.45,0,0,0-1-10Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "328.585px 293.2px"
    },
    id: "elpkmds6t0rsg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.37,270.76c-2.8-.95-7.52-.95-12.69,3.84-2.83,2.62-8.09,7.94-12,12.17a35.42,35.42,0,0,1,5.83,13.5l13-10.81A17.06,17.06,0,0,0,354.37,270.76Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "342.427px 285.267px"
    },
    id: "el64vv0ykixxs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-12",
    className: "animable",
    style: {
      transformOrigin: "328.999px 324.599px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.69,375.28s-2.54,9.94-4.24,13.06a49,49,0,0,1-6.73,9.85c-.64.71-2.09,2-2.61,2.61a1.14,1.14,0,0,0,.08,1.75c1.26,1.25,6.69,1.63,9.77-.59s5.68-5.93,7.53-7.73l2.43-2.41a2.45,2.45,0,0,0,.65-2.33c-.06-.24-.12-.52-.2-.84-.65-2.95,2.87-10.38,2.87-10.38C303.69,374.6,300,374.75,296.69,375.28Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "294.489px 389.278px"
    },
    id: "elwu795g0sd6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.74,392.49a3,3,0,0,1-.17,1.48c-.31.67-2.23,1.85-3.22,2.31a5.27,5.27,0,0,0-2.65,2.64,11.62,11.62,0,0,1-5.29,5.1,16.06,16.06,0,0,1-9.51.8c-4-.79-4.24-3.14-4.24-3.14s-.16-2.21.83-2.54S303.74,392.49,303.74,392.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "291.209px 398.845px"
    },
    id: "elzos0naaeua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.89,385.7a4.21,4.21,0,0,0,0,1.05c.1,1.1.19,1.79.24,3a6.31,6.31,0,0,1-.43,2.7c-1.2,1.6-4,2.08-5.62,4.26s-3.6,5.56-8.82,6.49-9.13-.8-10.07-2.29,0-2.88,3.34-4.62c3.58-1.84,7.88-6.86,7.88-6.86.43-.5.82-1.07,1.2-1.61a7.09,7.09,0,0,0,1.16-2,8.48,8.48,0,0,0,.43-2.33.28.28,0,0,1,.05-.2.35.35,0,0,1,.18-.06,9.05,9.05,0,0,1,5.56,1.3,1.27,1.27,0,0,1,.45.38,1.46,1.46,0,0,1,.18.45c.11.42.23.84.34,1.26a1.17,1.17,0,0,0,.53.84c.38.17.8-.1,1.13-.36s.55-.85.91-1.12A1.78,1.78,0,0,1,303.89,385.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "291.493px 393.327px"
    },
    id: "elljuk6uzrv3r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,402.07a6.59,6.59,0,0,0-3.74-5.72c-3.88-2.09-6.29-.84-7.5,0-1.45,1-3.54,3.11-2.33,4.69s3.44,2.55,7.44,2.68A9.5,9.5,0,0,0,292.69,402.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "285.724px 399.477px"
    },
    id: "el1b32pmkka6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.3,323.78c-1.87,5.37-2.53,11.46-9.57,16.41-6.4,4.51-20.7,7.92-22.5,8.8s-3,1.21-3.78,4.13c-1.05,4-1.18,7-4.92,14-2.63,4.94-4.65,8.46-6.73,12.1-1.9.21-8.38-1.56-9.35-3.08.48-3.06,5.91-32.15,9.2-38.51,2.77-5.36,37.29-22.91,37.29-22.91S355.17,318.42,353.3,323.78Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "324.972px 346.979px"
    },
    id: "elrp84qmqi8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7v8e7ec6c6a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.3,323.78c-1.87,5.37-2.53,11.46-9.57,16.41-6.4,4.51-20.7,7.92-22.5,8.8s-3,1.21-3.78,4.13c-1.05,4-1.18,7-4.92,14-2.63,4.94-4.65,8.46-6.73,12.1-1.9.21-8.38-1.56-9.35-3.08.48-3.06,5.91-32.15,9.2-38.51,2.77-5.36,37.29-22.91,37.29-22.91S355.17,318.42,353.3,323.78Z",
    style: {
      opacity: 0.35,
      transformOrigin: "324.972px 346.979px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0flz07cgsy39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.8,379.25a13.78,13.78,0,0,1-4-.61,7.61,7.61,0,0,1,.63-1.17,95.07,95.07,0,0,0,5.93-11c4.38-8.85,4.59-16.28,7-20.11,2.06-3.27,15.81-6.42,20.86-7.65,4.09-1,5.93-2.32,7.22-4.21s-2.42-6.09-1.72-10a20.75,20.75,0,0,0,7.33,9c-.54,1.2-9.92,9.22-9.92,9.22-5.63,2.57-12.82,4.58-16.18,5.64h0l-.83.27-.09,0-.23.08-.09,0-.19.07-.06,0-.19.08-1,.47a4.45,4.45,0,0,0-2,1.59,7.23,7.23,0,0,0-.84,2.07c-.06.25-.13.5-.19.74-.17.73-.33,1.44-.49,2.16-.06.23-.11.47-.17.72-.17.72-.36,1.47-.6,2.27-.08.26-.16.54-.25.81-.18.56-.39,1.15-.63,1.78a49.55,49.55,0,0,1-2.59,5.55l-.49.91c-1,1.79-1.84,3.39-2.67,4.89-.14.25-.28.49-.41.74l-1.6,2.83-1.17,2.05-.39.68Z",
    style: {
      opacity: 0.1,
      transformOrigin: "325.425px 351.875px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324.39,388.25s-2.53,9.94-4.23,13.06a49,49,0,0,1-6.73,9.85c-.64.71-2.09,2-2.62,2.61a1.14,1.14,0,0,0,.09,1.75c1.26,1.25,6.68,1.63,9.77-.59s5.68-5.93,7.52-7.73c.93-.91,1.8-1.77,2.43-2.41a2.48,2.48,0,0,0,.66-2.33c-.06-.24-.13-.52-.2-.84-.65-2.95,2.87-10.38,2.87-10.38C331.4,387.57,327.69,387.72,324.39,388.25Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "322.197px 402.248px"
    },
    id: "elrmekc56siwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.45,405.46a2.91,2.91,0,0,1-.18,1.48c-.3.67-2.23,1.84-3.21,2.31a6.1,6.1,0,0,0-2.65,2.64,12.84,12.84,0,0,1-5.3,5.1,16,16,0,0,1-9.51.8c-4-.79-4.23-3.14-4.23-3.14s-.17-2.21.83-2.54S331.45,405.46,331.45,405.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "318.918px 411.816px"
    },
    id: "elzzsj52nmxbs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.59,398.67a4.78,4.78,0,0,0,.05,1.05c.1,1.1.19,1.79.23,3a6.32,6.32,0,0,1-.42,2.7c-1.21,1.6-4,2.08-5.62,4.26s-3.6,5.56-8.82,6.49-9.14-.8-10.07-2.29,0-2.88,3.34-4.62c3.58-1.84,7.88-6.86,7.88-6.86.43-.5.81-1.07,1.2-1.61a7.62,7.62,0,0,0,1.16-2,8.85,8.85,0,0,0,.42-2.33.28.28,0,0,1,.06-.2.32.32,0,0,1,.18-.06,9.05,9.05,0,0,1,5.56,1.3,1.36,1.36,0,0,1,.45.38,1.44,1.44,0,0,1,.17.45l.35,1.26a1.19,1.19,0,0,0,.52.84c.38.17.8-.1,1.13-.36s.56-.85.92-1.13A1.81,1.81,0,0,1,331.59,398.67Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "319.241px 406.297px"
    },
    id: "elgwocrta5cua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,415a6.61,6.61,0,0,0-3.74-5.72c-3.88-2.09-6.29-.84-7.51,0-1.45,1-3.53,3.11-2.32,4.69s3.44,2.55,7.44,2.68A9.5,9.5,0,0,0,320.4,415Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "313.433px 412.407px"
    },
    id: "elirbaizc3dtj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.29,320.09c.95,5.32,2.2,13.62-1,18.3-3,4.33-6.95,7.26-14.21,11.89-8,5.11-12,7.6-13.88,8.94a9.77,9.77,0,0,0-4.29,6.19,49.53,49.53,0,0,1-4.67,14c-2.66,5.64-5.61,10.81-7.11,13.67-2.25.38-7.86-.7-9.33-2.6.81-4.27,5.47-34.55,7.46-39S349,333.54,349,333.54s1.24-8.14,0-13.45Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "351.574px 356.623px"
    },
    id: "elneb43itp4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elw59nyuqnrj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.29,320.09c.95,5.32,2.2,13.62-1,18.3-3,4.33-6.95,7.26-14.21,11.89-8,5.11-12,7.6-13.88,8.94a9.77,9.77,0,0,0-4.29,6.19,49.53,49.53,0,0,1-4.67,14c-2.66,5.64-5.61,10.81-7.11,13.67-2.25.38-7.86-.7-9.33-2.6.81-4.27,5.47-34.55,7.46-39S349,333.54,349,333.54s1.24-8.14,0-13.45Z",
    style: {
      opacity: 0.35,
      transformOrigin: "351.574px 356.623px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsewlx10zc0g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.36,371c1.07-3.62.87-7.35,1.82-11,1-4,4.49-6.78,7.74-9.3l10-7.76a14.42,14.42,0,0,0,2.9-2.72,7.16,7.16,0,0,0,1.26-5.34,8.17,8.17,0,0,0-3.84-5.33c-2.76-1.89-5.7-3.48-8.47-5.35a25.23,25.23,0,0,1-7.2-6.87c-.06-.1-1-2-.75-2l36.44,4.76c.21,1.16.43,2.47.62,3.85l.15,1.2c.12,1,.21,2.05.25,3.09,0,.41,0,.83,0,1.25,0,.62,0,1.24-.05,1.85,0,.41-.05.82-.1,1.22a17.36,17.36,0,0,1-.55,2.87,10.48,10.48,0,0,1-1.37,3l-.57.8a25,25,0,0,1-1.89,2.23,29.86,29.86,0,0,1-2.21,2.11c-.54.46-1.1.92-1.71,1.39s-1.24.94-1.92,1.42c-1.69,1.21-3.64,2.49-5.91,3.94l-2.81,1.8-6.42,4.08-.8.52c-1.79,1.15-3,1.95-3.85,2.54a12.55,12.55,0,0,0-2.34,2.12,8.71,8.71,0,0,0-2,4.07,49.53,49.53,0,0,1-4.67,14c-1.33,2.82-2.73,5.53-4,7.88-.47.88-.92,1.72-1.34,2.49-.7,1.29-1.31,2.41-1.78,3.3a12.84,12.84,0,0,1-4.12-.26,10,10,0,0,1,.85-1.93A120.28,120.28,0,0,0,338.36,371Z",
    style: {
      opacity: 0.1,
      transformOrigin: "354.075px 354.251px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,271.31c6.86,1.27,11.44,2.75,12.74,4,2.92,6-.88,26-.88,26l.39,9.37,1.64,9.36c-7.41,6.27-32.86,4-36.91-4.75,0,0,1.31-27.23,1.82-32.27.58-5.82,3.75-11.92,11.53-12.37Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "360.305px 297.126px"
    },
    id: "ely9kox9om3bl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.87,317.59c2-3.06,3.72-10.88,3.72-10.88s-3.28-20.44-2.48-25.26l7.16,9.06c-.58,5.79-1.54,10.84-1.54,10.84l.39,9.37,1.64,9.36c-5.93,5-22.54,5.71-32.83-.63C356.83,323.05,367.88,320.64,369.87,317.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "362.345px 302.734px"
    },
    id: "elmoqp69fi3qi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.9,244.4c0,7.59-6.3,17.45-13.89,17.45s-13.87-7-13.6-17.45c.19-7.59,5-7.28,12.57-7.28S368.9,236.81,368.9,244.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.151px 249.484px"
    },
    id: "el87tfvxjihzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.77,252.74s-1.11,8.14-1.69,9.5a3.65,3.65,0,0,1-2,1.85l-.31-5.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "368.77px 258.415px"
    },
    id: "eluz0havlmqv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.77,241.42a4,4,0,0,1,3.35.91c1.51,1.33,1.07,5.88-.35,10.41l-3.19.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.822px 247.351px"
    },
    id: "eliq573delq4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.62,253.42c.67.34,1.5-1,2.23-1.86s3.24-2.22,4.74.41-.66,6.53-2.65,7.33c-3.44,1.36-4.14-.85-4.14-.85l.75,14c-3.19,6.94-18.48,6.56-11.56-.2l-.26-4.4a36.64,36.64,0,0,1-5.3.39c-2.62-.2-4.16-1.57-5.16-4.32-1.6-4.4-2-8.34-1.59-17.26.45-9.79,11.72-10.73,18.09-7.35S366.62,253.42,366.62,253.42Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "358.811px 257.514px"
    },
    id: "ely2skrtzfswq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.84,236.16a31.28,31.28,0,0,0-6.8-1.5c-5-.7-10.08-1.31-14.74-3.25a3.12,3.12,0,0,0-1.8-.37c-1.17.24-1.58,1.71-1.54,2.91a10,10,0,0,0,.67,3.24,1.89,1.89,0,0,0-2.64.24,3.27,3.27,0,0,0-.56,2.82,6.92,6.92,0,0,0,4.34,4.72,15.76,15.76,0,0,0,6.59.8,45,45,0,0,0,9.21-1.39,6.52,6.52,0,0,1,2.23-.33,2,2,0,0,1,1.77,1.21c.42,1.19,1.38,9.5,3.1,9.4.31,0,1.37-2.2,2.1-3,.93-1,1.39-8.22,1.47-9.55a.62.62,0,0,1,.12-.29c1-1.65-.51-4.2-2-4.95A12.16,12.16,0,0,0,366.84,236.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.002px 242.843px"
    },
    id: "el609xlyh6v6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.75,242a2.35,2.35,0,0,0,3.34-3.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "371.761px 240.693px"
    },
    id: "ela6oiwg2uzgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.73,267.81s5.74-1,7.68-2.21a6.7,6.7,0,0,0,2.58-3,9.12,9.12,0,0,1-1.34,3.38c-1.34,2-8.79,4-8.79,4Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "360.86px 266.29px"
    },
    id: "elox8i2x6o40r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.16,252.76a1.16,1.16,0,1,0,1.07-1.29A1.19,1.19,0,0,0,355.16,252.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "356.314px 252.627px"
    },
    id: "elm703lq8zid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.06,248.3l2.58,1.18a1.5,1.5,0,0,0-.73-1.93A1.39,1.39,0,0,0,356.06,248.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.408px 248.456px"
    },
    id: "eliz0kpstcey",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.74,260.82,353.17,262a1.39,1.39,0,0,0,1.86.74A1.48,1.48,0,0,0,355.74,260.82Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "354.516px 261.842px"
    },
    id: "elo6xglsonc9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.9,250.13l2.13-1.91a1.38,1.38,0,0,0-2-.15A1.5,1.5,0,0,0,344.9,250.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.791px 248.92px"
    },
    id: "el5vtun0h4aom",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.83,253.15a1.16,1.16,0,1,0,1.06-1.29A1.18,1.18,0,0,0,345.83,253.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.983px 253.016px"
    },
    id: "eltj387pgahp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.73 251.96 351.87 258.94 348.14 257.98 351.73 251.96",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "350.005px 255.45px"
    },
    id: "el5es3hmtcus4",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M399.76,306.56l-.76,4.21-38.27,30.38A12.64,12.64,0,0,0,356,350l-4.53,47a.75.75,0,0,0,.38.73.76.76,0,0,0,.81,0h0l14.65-8.54v-3.08l-12.17,7.12L360.49,353a12.66,12.66,0,0,1,5.7-8.58l32.65-20.64A10.57,10.57,0,0,0,399.76,306.56Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "377.615px 352.203px"
    },
    id: "elh3wnst26lu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.24,316.14c.89,1.61,1.88,6.61,1,7.51a12.56,12.56,0,0,1-3.35,2.3,60.19,60.19,0,0,1-5.89,2.53c-4,1.52-8.39,2.76-12.14,3.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.721px 324.23px"
    },
    id: "ele7dpy2dm2uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.7,312.88c-1.48-5.85-6.12-22.44-7.61-27.75-2.42-8.66-5-9.69-8.91-10.53-3.11,2.46-6.15,11.67-2,20l6.08,21.63s-1.2.88-6.29,5.4c-4.58,4.06-6.38,5.43-8.43,7a72.23,72.23,0,0,0-5.77,4.61c-.75.71-7,8.65-6.89,10.18.11,1.37,1.38,2.38,3.87,2.74,2.28.33,3.89-.88,5.46-2.38.25-.24.5-.5.74-.76a12.11,12.11,0,0,1,3.17-2.52,17.26,17.26,0,0,0,2.88-1.91c1.22-1,1.6-2.15,3.37-3.28s12.2-7.72,17.83-11.3C394.79,321.07,394.4,319.61,392.7,312.88Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "373.378px 310.407px"
    },
    id: "elsoeauoxl5pb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.29,316.2s3.06-1.76,8.29,0a10.7,10.7,0,0,0-8.64-1.24Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "384.26px 315.375px"
    },
    id: "el9ra4ntxroju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.41,273.82c5.95.69,8.15,2.45,10.29,8.89S391,305.34,391,305.34s-6.6,3.8-13.61,3.23l-4.65-16.15S366.51,279.15,374.41,273.82Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "380.703px 291.224px"
    },
    id: "elrf16mtc21kg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.87,381.38v3.67a18.8,18.8,0,0,0,2.79,9.88c.13.22.28.44.42.65l0,.07.39.54a18.9,18.9,0,0,0,13.19,7.65l.15,0,.28,0,.56,0h.21l.65,0h.23a23.08,23.08,0,0,0,11-3.43l1.6-.93c13.92-8,25.2-27.58,25.2-43.65v-1.86c0-.35,0-.71,0-1.05v-.75a18.76,18.76,0,0,0-2.27-9l0,0a3.9,3.9,0,0,0-.19-.35l-.14-.26c-.13-.23-.28-.46-.43-.69l-.23-.35-.2-.28c-.1-.14-.2-.27-.31-.4l-.18-.22a18.84,18.84,0,0,0-12.9-7.2,13.94,13.94,0,0,0-1.72-.1h-.29a22.83,22.83,0,0,0-11,3.43l-1.61.93C376.15,345.77,364.87,365.31,364.87,381.38Zm9.45.93c0-13.57,9.53-30.07,21.28-36.85s21.28-1.29,21.28,12.28-9.53,30.07-21.28,36.85S374.32,395.88,374.32,382.31Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "393.205px 368.58px"
    },
    id: "el4e4i1zg0fm5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.6,384.11V386c0,7.95,2.76,13.55,7.23,16.22l.22.13.14.07.09.05a2.91,2.91,0,0,0,.35.18,6.51,6.51,0,0,0,.71.33l.34.14.4.14.37.12c.29.09.58.18.89.25a3.26,3.26,0,0,0,.47.09,3.56,3.56,0,0,0,.49.09l.55.08.28,0,.56,0h.21l.65,0a22.93,22.93,0,0,0,11.25-3.44l1.6-.93c13.92-8,25.2-27.58,25.2-43.65v-1.86c0-.35,0-.71,0-1.05s0-.59,0-.87v-.32c0-.26,0-.52-.07-.77a.77.77,0,0,0,0-.15c0-.3-.06-.59-.1-.88s-.07-.53-.12-.78-.05-.3-.07-.45c-.06-.31-.13-.63-.19-.93s-.13-.54-.2-.8c-.13-.48-.27-.95-.43-1.41v0c-.08-.25-.17-.49-.27-.73-.18-.46-.38-.91-.58-1.33l-.18-.35a3.9,3.9,0,0,0-.19-.35l-.14-.26c-.13-.23-.28-.46-.43-.69l-.23-.35-.2-.28c-.1-.14-.2-.27-.31-.4s-.21-.27-.32-.39l-.33-.38c-.22-.25-.46-.48-.7-.71l-.36-.32c-.25-.22-.5-.42-.76-.61l-.4-.28-.41-.26-.08-.05-.35-.21c-4.55-2.54-10.79-2.13-17.68,1.84l-1.6.94C380.88,348.5,369.6,368,369.6,384.11Zm4.72-1.8c0-13.57,9.53-30.07,21.28-36.85s21.28-1.29,21.28,12.28-9.53,30.07-21.28,36.85S374.32,395.88,374.32,382.31Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "395.6px 369.973px"
    },
    id: "el8f0npkgcsv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.78,391.11c3.36,4,9.19,4.58,15.82.75,10.45-6,18.91-20.69,18.91-32.75,0-5.39-1.69-9.35-4.5-11.54,2,2.31,3.09,5.76,3.09,10.17,0,12.06-8.46,26.73-18.91,32.76C388.42,393.84,383.24,393.83,379.78,391.11Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "397.145px 371.006px"
    },
    id: "el0zuj10h4nhqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpms813snm6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.78,391.11c3.36,4,9.19,4.58,15.82.75,10.45-6,18.91-20.69,18.91-32.75,0-5.39-1.69-9.35-4.5-11.54,2,2.31,3.09,5.76,3.09,10.17,0,12.06-8.46,26.73-18.91,32.76C388.42,393.84,383.24,393.83,379.78,391.11Z",
    style: {
      opacity: 0.2,
      transformOrigin: "397.145px 371.006px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.33,382.31c0,13.57,9.52,19.07,21.27,12.28s21.28-23.28,21.28-36.85-9.53-19.07-21.28-12.28S374.33,368.74,374.33,382.31Zm2.36-1.37c0-12.06,8.47-26.72,18.91-32.75s18.91-1.14,18.91,10.92S406,385.83,395.6,391.86,376.69,393,376.69,380.94Z",
    style: {
      fill: "rgb(255, 193, 0)",
      transformOrigin: "395.605px 370.025px"
    },
    id: "elypu929lp90g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,374.94c0-.21.09-.42.14-.64l16.47-4.41.37-.55-12.11-7,.3-.5,12.1,7,.29-.6-4.37-16.32.49-.43,4.3,16,.58-.66,4.23-20.66.63-.17-4.17,20.38.66-.09,11.35-19.67.51.29-11.36,19.66.25.63,15.73-13.95c.06.21.12.41.17.62l-15.95,14.15-.28.83L414,364.52c0,.21-.08.42-.13.63l-16.6,4.45-.37.55,12.34,7.13-.28.51-12.35-7.13-.29.6L400.8,388l-.49.44L395.89,372l-.58.66L391,393.88l-.63.16,4.29-21-.66.1-11.6,20.09-.5-.3,11.6-20.08-.25-.63-15.85,14.06c-.06-.21-.11-.42-.16-.63l16.06-14.25.28-.83Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "395.62px 370.02px"
    },
    id: "el9luhxsb7b5l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.41,373.5c0,2.22.77,3.79,2,4.54.38.23.69.38,1,.59a3.8,3.8,0,0,0,2.32.54h0l.51-.08.15,0,.41-.11.28-.08.29-.12a3.69,3.69,0,0,0,.42-.17c.24-.11.48-.23.73-.37a15.69,15.69,0,0,0,7.09-12.29c0-.27,0-.53,0-.79,0-.09,0-.17,0-.26s0-.31-.06-.46a2.81,2.81,0,0,0-.08-.31c0-.12-.05-.23-.08-.35l-.12-.32c0-.09-.06-.18-.1-.27a3.24,3.24,0,0,0-.17-.32,1.86,1.86,0,0,0-.1-.2,3.62,3.62,0,0,0-.22-.32l-.09-.13c-.09-.11-.19-.21-.28-.31l-.08-.07c-.11-.1-.22-.2-.34-.29h0l-.05,0-.27-.18c-.35-.2-.67-.35-.94-.52-1.29-.81-3.1-.74-5.11.43A15.67,15.67,0,0,0,387.41,373.5Zm8.9,1.48c-.59-1.14-.7-3.38,0-4.24s.71.4,2.55-.55a14,14,0,0,0,1.24-.76,17.37,17.37,0,0,1-3.59,5.42A.85.85,0,0,1,396.31,375ZM392,366.25a1.11,1.11,0,0,1,.08-.21,12,12,0,0,1,4.64-3.6,9.88,9.88,0,0,1-1.89,5.3,1.39,1.39,0,0,0-.54-.54l-1.09-.62a1.8,1.8,0,0,0-.31-.14A4.17,4.17,0,0,0,392,366.25Zm7.32-4.1a5.44,5.44,0,0,1,1.22,3.6c-.15,1.35-2.42,2.7-3.81,2.93.05-.7,1-1,1.55-3.17C398.8,363.75,398.76,362.41,399.36,362.15Zm-8.49,15-.07-.08c-.56-.9,1.62-3.91,3.07-5.05a3.69,3.69,0,0,0,0,2c.38,1.4,1.2,2.06.46,2.73A4.67,4.67,0,0,1,390.87,377.12Zm-1.44-2.92a13.41,13.41,0,0,1,1.21-5.29,1.8,1.8,0,0,1,2.23-.75,1.42,1.42,0,0,1,.5,1.48c-.37,1.1-1,.39-2.52,2.45C390.26,372.87,389.8,373.65,389.43,374.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "395.01px 369.748px"
    },
    id: "elokfmtonns9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpd0y2jbc2m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.41,373.5c0,2.22.77,3.79,2,4.54.38.23.69.38,1,.59a3.8,3.8,0,0,0,2.32.54h0l.51-.08.15,0,.41-.11.28-.08.29-.12a3.69,3.69,0,0,0,.42-.17c.24-.11.48-.23.73-.37a15.69,15.69,0,0,0,7.09-12.29c0-.27,0-.53,0-.79,0-.09,0-.17,0-.26s0-.31-.06-.46a2.81,2.81,0,0,0-.08-.31c0-.12-.05-.23-.08-.35l-.12-.32c0-.09-.06-.18-.1-.27a3.24,3.24,0,0,0-.17-.32,1.86,1.86,0,0,0-.1-.2,3.62,3.62,0,0,0-.22-.32l-.09-.13c-.09-.11-.19-.21-.28-.31l-.08-.07c-.11-.1-.22-.2-.34-.29h0l-.05,0-.27-.18c-.35-.2-.67-.35-.94-.52-1.29-.81-3.1-.74-5.11.43A15.67,15.67,0,0,0,387.41,373.5Zm8.9,1.48c-.59-1.14-.7-3.38,0-4.24s.71.4,2.55-.55a14,14,0,0,0,1.24-.76,17.37,17.37,0,0,1-3.59,5.42A.85.85,0,0,1,396.31,375ZM392,366.25a1.11,1.11,0,0,1,.08-.21,12,12,0,0,1,4.64-3.6,9.88,9.88,0,0,1-1.89,5.3,1.39,1.39,0,0,0-.54-.54l-1.09-.62a1.8,1.8,0,0,0-.31-.14A4.17,4.17,0,0,0,392,366.25Zm7.32-4.1a5.44,5.44,0,0,1,1.22,3.6c-.15,1.35-2.42,2.7-3.81,2.93.05-.7,1-1,1.55-3.17C398.8,363.75,398.76,362.41,399.36,362.15Zm-8.49,15-.07-.08c-.56-.9,1.62-3.91,3.07-5.05a3.69,3.69,0,0,0,0,2c.38,1.4,1.2,2.06.46,2.73A4.67,4.67,0,0,1,390.87,377.12Zm-1.44-2.92a13.41,13.41,0,0,1,1.21-5.29,1.8,1.8,0,0,1,2.23-.75,1.42,1.42,0,0,1,.5,1.48c-.37,1.1-1,.39-2.52,2.45C390.26,372.87,389.8,373.65,389.43,374.2Z",
    style: {
      opacity: 0.2,
      transformOrigin: "395.01px 369.748px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.51,374.12c0,4.52,3.17,6.35,7.09,4.1a15.69,15.69,0,0,0,7.09-12.29c0-4.52-3.17-6.35-7.09-4.1A15.69,15.69,0,0,0,388.51,374.12Zm7.11-5.51c-.85.35-.17-1-1.6-1.55-1.13-.4-2.37,0-1.9-1s3.83-3.7,5.24-3.72S396.85,368.1,395.62,368.61Zm6.05-2.25c-.22,1.91-4.68,3.85-4.89,2.55-.15-.88.88-1,1.54-3.4.52-1.87.43-3.29,1.15-3.41S401.88,364.46,401.67,366.36Zm-5.34,4.38c.75-.89.71.4,2.55-.55,1.45-.75,2.63-2,2.61-1.09s-2.34,5.17-3.87,6.36S395.23,372.05,396.33,370.74Zm-1.43.83c.61.33-.45,1.29,0,3.06.38,1.4,1.2,2.06.47,2.74s-3.87.83-4.6-.33S394,371.09,394.9,371.57Zm-5.3,3.91c-.44-.48,0-4.65,1-6.57s4.37-.27,3.81,1.34c-.37,1.1-1,.4-2.52,2.45C390.71,374.32,390,376,389.6,375.48Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "395.6px 370.025px"
    },
    id: "eljohgxcmofr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.6,372.53c-1.2.69-2.17.13-2.17-1.25a4.78,4.78,0,0,1,2.17-3.76c1.2-.69,2.17-.13,2.17,1.25A4.78,4.78,0,0,1,395.6,372.53Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "395.6px 370.025px"
    },
    id: "elb678sp2n6fp",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.55de444181382d194baf449fc5d05d7a.svg";
export { ForwardRef as ReactComponent };